// AUTO-GENERATED by scripts/gen-blog-index.ts — do not edit by hand.
// Lightweight blog index (no article bodies) for internal-linking components.
export type BlogCategory = "Notary" | "Translation" | "Visa" | "Legalization" | "Legal";

export type BlogCardMeta = {
  slug: string;
  title: string;
  category: BlogCategory;
  tags: string[];
  readMinutes: number;
  excerpt: string;
  author: string;
  publishedAt: string;
  updatedAt: string;
};

export const BLOG_INDEX: BlogCardMeta[] = [
 {
  "slug": "notary-public-thailand-complete-guide-2026",
  "title": "Notary Public ในไทยคืออะไร? คู่มือฉบับสมบูรณ์ปี 2026",
  "category": "Notary",
  "tags": [
   "notary",
   "notarial-services-attorney",
   "รับรองเอกสาร",
   "Apostille"
  ],
  "readMinutes": 9,
  "excerpt": "Notary Public ในไทยจริงๆ คือ Notarial Services Attorney (ทนายผู้ทำคำรับรอง) ขึ้นทะเบียนกับสภาทนายความฯ บทความนี้สรุปทุกอย่างที่ต้องรู้ก่อนใช้บริการ",
  "author": "NYC Legal Team",
  "publishedAt": "2026-04-12",
  "updatedAt": "2026-05-15"
 },
 {
  "slug": "apostille-vs-consular-legalization",
  "title": "Apostille vs Consular Legalization — เลือกแบบไหนเมื่อไหร่?",
  "category": "Legalization",
  "tags": [
   "Apostille",
   "MFA",
   "กงสุล",
   "consular"
  ],
  "readMinutes": 7,
  "excerpt": "ประเทศกว่า 130 ประเทศใช้ Apostille แล้ว — แต่ไทยยื่นภาคยานุวัติสารเข้าเป็นภาคีอนุสัญญา Apostille เมื่อ 30 มิ.ย. 2569 (มีผลบังคับใช้กับไทย 28 ก.พ. 2570)",
  "author": "NYC Legal Team",
  "publishedAt": "2026-03-20",
  "updatedAt": "2026-05-10"
 },
 {
  "slug": "naati-translation-australia-guide",
  "title": "NAATI Certified Translation สำหรับขอวีซ่า/เรียนต่อออสเตรเลีย",
  "category": "Translation",
  "tags": [
   "NAATI",
   "วีซ่าออสเตรเลีย",
   "เรียนต่อ",
   "translation"
  ],
  "readMinutes": 8,
  "excerpt": "NAATI คือมาตรฐานการแปลที่รัฐบาลออสเตรเลียยอมรับเพียงรายเดียวสำหรับวีซ่า/เรียนต่อ/ทำงาน บทความนี้สรุปทุกอย่างที่ต้องรู้",
  "author": "NYC Legal Team",
  "publishedAt": "2026-02-28",
  "updatedAt": "2026-05-08"
 },
 {
  "slug": "legal-translation-thai-english-2026",
  "title": "Legal Translation ไทย-อังกฤษ: คู่มือเลือกผู้แปลที่ถูกต้องตามกฎหมาย",
  "category": "Translation",
  "tags": [
   "legal-translation",
   "แปลกฎหมาย",
   "สัญญา",
   "ISO 17100"
  ],
  "readMinutes": 10,
  "excerpt": "การแปลเอกสารกฎหมายต้องการมากกว่าทักษะภาษา — ต้องอาศัยความเข้าใจระบบกฎหมายทั้ง 2 ฝั่ง บทความนี้รวมทุกเช็กลิสต์ก่อนเลือกบริษัท",
  "author": "NYC Legal Team",
  "publishedAt": "2026-01-18",
  "updatedAt": "2026-05-02"
 },
 {
  "slug": "ltr-visa-thailand-complete-guide",
  "title": "LTR Visa ประเทศไทย 2026 — สำหรับชาวต่างชาติ 4 กลุ่ม",
  "category": "Visa",
  "tags": [
   "LTR Visa",
   "วีซ่าระยะยาว",
   "BOI",
   "expat"
  ],
  "readMinutes": 11,
  "excerpt": "LTR (Long-Term Resident) Visa คือวีซ่า 10 ปีของไทย ออกโดย BOI สำหรับชาวต่างชาติ 4 กลุ่ม บทความนี้สรุปทุกอย่างที่ต้องเตรียม",
  "author": "NYC Legal Team",
  "publishedAt": "2025-12-10",
  "updatedAt": "2026-04-30"
 },
 {
  "slug": "foreign-marriage-in-thailand-guide",
  "title": "แต่งงานในไทยสำหรับชาวต่างชาติ — เอกสาร 7 อย่างที่ต้องเตรียม",
  "category": "Legal",
  "tags": [
   "marriage",
   "แต่งงาน",
   "Affirmation",
   "Single Status"
  ],
  "readMinutes": 8,
  "excerpt": "การแต่งงานในไทยกับชาวต่างชาติทำได้ภายใน 1 สัปดาห์ ถ้าเตรียมเอกสารถูกต้อง บทความนี้สรุป 7 รายการสำคัญ",
  "author": "NYC Legal Team",
  "publishedAt": "2025-11-15",
  "updatedAt": "2026-04-22"
 },
 {
  "slug": "probate-foreign-inheritance-thailand",
  "title": "รับมรดกจากต่างประเทศ — Probate และการนำเข้าทรัพย์สิน",
  "category": "Legal",
  "tags": [
   "probate",
   "มรดก",
   "พินัยกรรม",
   "inheritance"
  ],
  "readMinutes": 9,
  "excerpt": "การรับมรดกจากต่างประเทศมีหลายขั้นตอน ทั้งการขอ Probate, การแปล-รับรอง, การโอนเงิน ภาษี",
  "author": "NYC Legal Team",
  "publishedAt": "2025-10-20",
  "updatedAt": "2026-04-12"
 },
 {
  "slug": "boi-application-thailand-2026",
  "title": "BOI Promotion 2026 — คู่มือสมัครส่งเสริมการลงทุนไทย",
  "category": "Legal",
  "tags": [
   "BOI",
   "ส่งเสริมการลงทุน",
   "ภาษี",
   "investment"
  ],
  "readMinutes": 10,
  "excerpt": "BOI คือทางลัดที่นักลงทุนต่างชาติใช้ลงทุนในไทยอย่างถูกต้องและคุ้มภาษี บทความนี้สรุปครบในที่เดียว",
  "author": "NYC Legal Team",
  "publishedAt": "2025-09-05",
  "updatedAt": "2026-04-02"
 },
 {
  "slug": "schengen-visa-thailand-2026-complete-guide",
  "title": "ขอวีซ่าเชงเก้น (Schengen) จากไทย 2026 — คู่มือฉบับสมบูรณ์",
  "category": "Visa",
  "tags": [
   "Schengen",
   "วีซ่ายุโรป",
   "วีซ่าท่องเที่ยว",
   "VFS"
  ],
  "readMinutes": 10,
  "excerpt": "วีซ่าเชงเก้นใบเดียวเที่ยวได้ 29 ประเทศในยุโรป — แต่ปฏิเสธสูงถึง 18% สำหรับคนไทย บทความนี้สรุปทุกอย่างจากประสบการณ์เคสจริง 1,200+ เคส",
  "author": "NYC Legal Team",
  "publishedAt": "2026-05-02",
  "updatedAt": "2026-05-15"
 },
 {
  "slug": "trademark-registration-thailand-2026",
  "title": "จดเครื่องหมายการค้า (Trademark) ในไทย 2026 — ขั้นตอน + ค่าใช้จ่าย",
  "category": "Legal",
  "tags": [
   "Trademark",
   "เครื่องหมายการค้า",
   "IP",
   "DIP"
  ],
  "readMinutes": 9,
  "excerpt": "เครื่องหมายการค้าคือทรัพย์สินทางปัญญาที่มีมูลค่าสูงสุดของแบรนด์ — จดให้ถูกหมวด ถูกขั้นตอน ก่อนคนอื่นแย่งจดไปก่อน",
  "author": "NYC Legal Team",
  "publishedAt": "2026-04-22",
  "updatedAt": "2026-05-12"
 },
 {
  "slug": "last-will-testament-foreigner-thailand",
  "title": "พินัยกรรม (Last Will & Testament) สำหรับชาวต่างชาติในไทย",
  "category": "Legal",
  "tags": [
   "Will",
   "พินัยกรรม",
   "มรดก",
   "Probate"
  ],
  "readMinutes": 8,
  "excerpt": "ถ้าคุณเป็น Expat ที่มีทรัพย์สินในไทย — คอนโด รถยนต์ บัญชีธนาคาร — การไม่มีพินัยกรรมไทยจะทำให้ครอบครัวต้องเผชิญ Probate 2–5 ปี",
  "author": "NYC Legal Team",
  "publishedAt": "2026-04-08",
  "updatedAt": "2026-05-10"
 },
 {
  "slug": "us-k1-fiance-visa-thailand-guide",
  "title": "K-1 Fiancé(e) Visa สหรัฐฯ จากไทย — คู่มือฉบับทนาย 2026",
  "category": "Visa",
  "tags": [
   "K-1",
   "วีซ่าอเมริกา",
   "Fiancé",
   "USCIS"
  ],
  "readMinutes": 11,
  "excerpt": "K-1 Visa คือทางลัดสำหรับคนรักชาวอเมริกัน-คนไทย ใช้เวลา 8–12 เดือน ค่าใช้จ่ายรวมประมาณ $2,500 บทความนี้สรุปทุกขั้นตอนแบบทีละ Step",
  "author": "NYC Legal Team",
  "publishedAt": "2026-03-28",
  "updatedAt": "2026-05-09"
 },
 {
  "slug": "police-clearance-thailand-for-overseas",
  "title": "Police Clearance จากไทย ใช้ต่างประเทศ — คู่มือ 2026",
  "category": "Legalization",
  "tags": [
   "Police Clearance",
   "Criminal Record",
   "PR"
  ],
  "readMinutes": 6,
  "excerpt": "ใบรับรองความประพฤติเป็นเอกสารบังคับสำหรับวีซ่าถาวร/PR/ทำงานในต่างประเทศ — ใช้เวลา 21–45 วัน ค่าธรรมเนียม ฿100 (แต่ขั้นตอนยุ่งยาก)",
  "author": "NYC Legal Team",
  "publishedAt": "2026-03-14",
  "updatedAt": "2026-05-07"
 },
 {
  "slug": "sworn-translator-vs-certified-translation",
  "title": "Sworn Translator vs Certified Translation — ใช้อะไรเมื่อไร?",
  "category": "Translation",
  "tags": [
   "Sworn Translator",
   "Certified Translation",
   "นักแปลสาบาน"
  ],
  "readMinutes": 7,
  "excerpt": "หลายประเทศในยุโรปบังคับใช้ Sworn Translator เท่านั้น — ไม่ใช่แค่แปลรับรองธรรมดา หากใช้ผิดประเภท เอกสารจะถูกปฏิเสธทันที",
  "author": "NYC Legal Team",
  "publishedAt": "2026-02-15",
  "updatedAt": "2026-05-05"
 },
 {
  "slug": "pdpa-compliance-checklist-thailand-2026",
  "title": "PDPA Compliance Checklist สำหรับธุรกิจในไทย 2026",
  "category": "Legal",
  "tags": [
   "PDPA",
   "Privacy",
   "Data Protection",
   "Compliance"
  ],
  "readMinutes": 9,
  "excerpt": "PDPA บังคับใช้เต็มรูปแบบมา 3 ปีแล้ว — สคส. เริ่มสั่งปรับจริงในปี 2025 มีเคสที่บริษัท SaaS โดนปรับ ฿1.2M เพราะส่ง Database ออกนอกประเทศโดยไม่มี SCC",
  "author": "NYC Legal Team",
  "publishedAt": "2026-01-28",
  "updatedAt": "2026-05-03"
 },
 {
  "slug": "foreign-land-ownership-thailand-2026",
  "title": "ชาวต่างชาติซื้อที่ดินในไทยได้ไหม? — 7 วิธีถูกกฎหมาย 2026",
  "category": "Legal",
  "tags": [
   "Real Estate",
   "Foreign Ownership",
   "อสังหาริมทรัพย์",
   "Condo"
  ],
  "readMinutes": 10,
  "excerpt": "กฎหมายไทยห้ามชาวต่างชาติถือครองที่ดินโดยตรง — แต่มี 7 วิธีที่ถูกกฎหมาย แต่ละวิธีมีข้อดี-ข้อเสีย และความเสี่ยงต่างกัน",
  "author": "NYC Legal Team",
  "publishedAt": "2026-01-15",
  "updatedAt": "2026-05-01"
 },
 {
  "slug": "affidavit-of-single-status-thailand-guide",
  "title": "Affidavit of Single Status (หนังสือรับรองโสด) สำหรับใช้ต่างประเทศ",
  "category": "Legalization",
  "tags": [
   "Single Status",
   "Affidavit",
   "แต่งงานต่างประเทศ",
   "Notary"
  ],
  "readMinutes": 7,
  "excerpt": "ก่อนแต่งงานในเยอรมนี อเมริกา ญี่ปุ่น หรือสิงคโปร์ คุณต้องมีหนังสือรับรองโสดที่ผ่าน Notary + MFA + สถานทูต บทความนี้สรุปทุกขั้นตอน",
  "author": "NYC Legal Team",
  "publishedAt": "2026-05-01",
  "updatedAt": "2026-05-18"
 },
 {
  "slug": "power-of-attorney-thailand-foreigners",
  "title": "Power of Attorney (หนังสือมอบอำนาจ) ในไทย — คู่มือสำหรับชาวต่างชาติ",
  "category": "Legal",
  "tags": [
   "Power of Attorney",
   "หนังสือมอบอำนาจ",
   "Notary"
  ],
  "readMinutes": 8,
  "excerpt": "ไม่ได้อยู่ไทยแต่ต้องเซ็นเอกสารที่ไทย? Power of Attorney คือคำตอบ บทความนี้สรุปทุกแบบ + วิธีทำจากต่างประเทศ",
  "author": "NYC Legal Team",
  "publishedAt": "2026-04-22",
  "updatedAt": "2026-05-15"
 },
 {
  "slug": "work-permit-non-b-visa-thailand-2026",
  "title": "Work Permit + Non-B Visa ในไทย — คู่มือ HR และนายจ้าง 2026",
  "category": "Visa",
  "tags": [
   "Work Permit",
   "Non-B Visa",
   "ใบอนุญาตทำงาน"
  ],
  "readMinutes": 9,
  "excerpt": "นายจ้างไทยอยากจ้างชาวต่างชาติเข้าทำงาน? ต้องรู้สเปก ทุนจดทะเบียน อัตรา 4 คนไทยต่อ 1 ต่างชาติ และ Quota บทความนี้สรุปครบ",
  "author": "NYC Legal Team",
  "publishedAt": "2026-04-15",
  "updatedAt": "2026-05-17"
 },
 {
  "slug": "thailand-privilege-elite-visa-2026",
  "title": "Thailand Privilege (Elite) Visa 2026 — เทียบทุก Tier และคุ้มไหม?",
  "category": "Visa",
  "tags": [
   "Thailand Privilege",
   "Elite Visa",
   "long-stay"
  ],
  "readMinutes": 8,
  "excerpt": "Thailand Elite รีแบรนด์เป็น Thailand Privilege แล้ว 4 ระดับ ตั้งแต่ ฿900K ถึง ฿5M บทความนี้ช่วยเลือก Tier ที่ใช่และเทียบกับ LTR",
  "author": "NYC Legal Team",
  "publishedAt": "2026-04-08",
  "updatedAt": "2026-05-12"
 },
 {
  "slug": "uk-spouse-visa-translation-legalization",
  "title": "วีซ่าคู่สมรส UK (Spouse Visa) — แปลและรับรองเอกสารไทย",
  "category": "Translation",
  "tags": [
   "UK Visa",
   "Spouse Visa",
   "Certified Translation"
  ],
  "readMinutes": 7,
  "excerpt": "Home Office ของ UK เคร่งเรื่องคำแปล — ต้องระบุ ‘Certified Translation’ พร้อมข้อมูลผู้แปลครบ ไม่งั้นวีซ่าถูกปฏิเสธ",
  "author": "NYC Legal Team",
  "publishedAt": "2026-03-30",
  "updatedAt": "2026-05-14"
 },
 {
  "slug": "education-credential-evaluation-wes-iqas",
  "title": "ประเมินวุฒิการศึกษา WES / IQAS / ICAS — สำหรับขอ PR แคนาดา/อเมริกา",
  "category": "Translation",
  "tags": [
   "WES",
   "ECA",
   "Express Entry",
   "Canada PR"
  ],
  "readMinutes": 8,
  "excerpt": "Express Entry แคนาดาบังคับต้องมี ECA จาก WES/IQAS/ICAS — บทความนี้สรุปขั้นตอนและการแปลที่ถูกต้อง",
  "author": "NYC Legal Team",
  "publishedAt": "2026-03-25",
  "updatedAt": "2026-05-13"
 },
 {
  "slug": "thai-drivers-license-translation-idp",
  "title": "แปลใบขับขี่ไทย + IDP สำหรับขับรถต่างประเทศ",
  "category": "Translation",
  "tags": [
   "ใบขับขี่",
   "IDP",
   "International Driving Permit"
  ],
  "readMinutes": 5,
  "excerpt": "ขับรถต่างประเทศ ต้องมีอะไรบ้าง? IDP เพียวๆ หรือต้องแปลใบขับขี่ด้วย? บทความนี้สรุปตามประเทศปลายทาง",
  "author": "NYC Legal Team",
  "publishedAt": "2026-03-15",
  "updatedAt": "2026-05-10"
 },
 {
  "slug": "divorce-certificate-legalization-thailand",
  "title": "ใบหย่าไทย (คร.6/คร.7) — แปลและรับรองใช้ต่างประเทศ",
  "category": "Legalization",
  "tags": [
   "ใบหย่า",
   "Divorce Certificate",
   "คร.6"
  ],
  "readMinutes": 6,
  "excerpt": "เคยหย่าในไทยและกำลังจะแต่งงานใหม่ในต่างประเทศ? ต้องมีใบหย่าที่ผ่าน Notary + MFA + สถานทูต บทความนี้สรุปครบ",
  "author": "NYC Legal Team",
  "publishedAt": "2026-03-10",
  "updatedAt": "2026-05-09"
 },
 {
  "slug": "corporate-document-legalization-international",
  "title": "รับรองเอกสารบริษัทสำหรับธุรกิจระหว่างประเทศ — ครบทุกขั้นตอน",
  "category": "Legalization",
  "tags": [
   "Corporate",
   "Certificate of Incorporation",
   "บริษัท"
  ],
  "readMinutes": 8,
  "excerpt": "บริษัทไทยจะเปิด Subsidiary, เซ็น Contract หรือยื่น Tender ต่างประเทศ ต้องมีชุดเอกสารรับรองครบ บทความนี้สรุปครบ",
  "author": "NYC Legal Team",
  "publishedAt": "2026-02-20",
  "updatedAt": "2026-05-07"
 },
 {
  "slug": "fatca-crs-tax-residency-thailand",
  "title": "FATCA / CRS Tax Residency ในไทย — เอกสารที่ธนาคารต่างประเทศขอ",
  "category": "Legal",
  "tags": [
   "FATCA",
   "CRS",
   "Tax Residency",
   "TIN"
  ],
  "readMinutes": 7,
  "excerpt": "ธนาคารในสิงคโปร์ ฮ่องกง สวิส ขอ Tax Residency Certificate + TIN จากไทย? บทความนี้สรุปขั้นตอนครบ",
  "author": "NYC Legal Team",
  "publishedAt": "2026-02-10",
  "updatedAt": "2026-05-05"
 },
 {
  "slug": "mfa-consular-legalization-step-by-step-2026",
  "title": "รับรองเอกสารกงสุล MFA ครบทุกขั้นตอน — ไทม์ไลน์ ค่าธรรมเนียม คู่มือปี 2026",
  "category": "Legalization",
  "tags": [
   "MFA",
   "นิติกรณ์",
   "กงสุล",
   "รับรองเอกสาร",
   "กระทรวงการต่างประเทศ"
  ],
  "readMinutes": 11,
  "excerpt": "เอกสารที่ต้องนำไปใช้ต่างประเทศ ส่วนใหญ่ต้องผ่านการรับรองจากกองสัญชาติและนิติกรณ์ กรมการกงสุล กระทรวงการต่างประเทศ (MFA) ก่อน บทความนี้สรุปทุกขั้นตอนแบบเข้าใจง่าย",
  "author": "NYC Legalization Desk",
  "publishedAt": "2026-05-20",
  "updatedAt": "2026-05-29"
 },
 {
  "slug": "naati-online-worldwide-shipping-guide",
  "title": "NAATI Online ส่งทั่วโลก — บริการแปลรับรอง NAATI สำหรับคนไทยในต่างประเทศ",
  "category": "Translation",
  "tags": [
   "NAATI",
   "NAATI Online",
   "Translation",
   "Worldwide",
   "Certified Translator"
  ],
  "readMinutes": 10,
  "excerpt": "ลูกค้าคนไทยในต่างประเทศไม่ต้องกลับมาที่กรุงเทพฯ NYC ให้บริการแปลและรับรอง NAATI ออนไลน์เต็มรูปแบบ — รับงานทุกประเทศทั่วโลก",
  "author": "NYC NAATI Desk",
  "publishedAt": "2026-05-21",
  "updatedAt": "2026-05-29"
 },
 {
  "slug": "apec-business-travel-card-thailand-2026",
  "title": "APEC Business Travel Card (ABTC) สำหรับนักธุรกิจไทย — สิทธิ์ใน 21 Economies",
  "category": "Visa",
  "tags": [
   "APEC",
   "ABTC",
   "Business Visa",
   "นักธุรกิจ",
   "วีซ่า"
  ],
  "readMinutes": 10,
  "excerpt": "ABTC เป็นบัตรที่ช่วยให้นักธุรกิจไทยเข้า 21 ประเทศสมาชิก APEC ได้โดยไม่ต้องขอวีซ่าทุกครั้ง — ผ่าน Fast Lane ที่สนามบินด้วย",
  "author": "NYC Visa Desk",
  "publishedAt": "2026-05-22",
  "updatedAt": "2026-05-29"
 },
 {
  "slug": "medical-council-document-certification-thailand",
  "title": "รับรองเอกสารโดยแพทยสภา — คู่มือสำหรับใช้ในไทยและต่างประเทศ",
  "category": "Legalization",
  "tags": [
   "แพทยสภา",
   "Medical Council",
   "ใบรับรองแพทย์",
   "Legalization"
  ],
  "readMinutes": 9,
  "excerpt": "ใบรับรองแพทย์ ใบประกอบวิชาชีพ และเอกสารทางการแพทย์ที่จะใช้ต่างประเทศ ต้องผ่านการรับรองจากแพทยสภาก่อนยื่น MFA — บทความนี้สรุปทุกขั้นตอน",
  "author": "NYC Legalization Desk",
  "publishedAt": "2026-05-23",
  "updatedAt": "2026-05-29"
 },
 {
  "slug": "social-security-work-experience-certificate-thailand",
  "title": "ขอใบรับรองประสบการณ์ทำงานจากประกันสังคมและกระทรวงแรงงาน",
  "category": "Legalization",
  "tags": [
   "ประกันสังคม",
   "กระทรวงแรงงาน",
   "ใบรับรองงาน",
   "Work Experience"
  ],
  "readMinutes": 9,
  "excerpt": "ลูกค้าจำนวนมากต้องการใบรับรองประสบการณ์ทำงานจากนายจ้างเก่าที่ปิดกิจการ — สามารถขอจากประกันสังคมและกระทรวงแรงงานทดแทนได้ บทความนี้สรุปทุกขั้นตอน",
  "author": "NYC Documentation Desk",
  "publishedAt": "2026-05-24",
  "updatedAt": "2026-05-29"
 },
 {
  "slug": "police-clearance-thai-abroad-30-countries-guide",
  "title": "ตรวจประวัติอาชญากรรมสำหรับคนไทยใน 30+ ประเทศ — คู่มือฉบับเต็ม",
  "category": "Legal",
  "tags": [
   "Police Clearance",
   "ตรวจประวัติ",
   "คนไทยต่างประเทศ",
   "Criminal Record"
  ],
  "readMinutes": 11,
  "excerpt": "คนไทยที่อยู่ต่างประเทศและต้องการขอใบตรวจประวัติอาชญากรรมจากสำนักงานตำรวจแห่งชาติไทย ไม่จำเป็นต้องบินกลับ — NYC ให้บริการครบวงจรใน 30+ ประเทศ",
  "author": "NYC Police Clearance Desk",
  "publishedAt": "2026-05-25",
  "updatedAt": "2026-05-29"
 },
 {
  "slug": "embassy-legalization-by-country-complete-guide",
  "title": "รับรองเอกสารโดยสถานทูตทุกประเทศในไทย — Directory + Workflow ฉบับสมบูรณ์",
  "category": "Legalization",
  "tags": [
   "Embassy",
   "สถานทูต",
   "Legalization",
   "รับรองเอกสาร"
  ],
  "readMinutes": 10,
  "excerpt": "หลังจากเอกสารผ่าน MFA แล้ว ขั้นตอนสุดท้ายคือการรับรองโดยสถานทูตประเทศปลายทาง — บทความนี้รวบรวม Directory สถานทูตทุกประเทศในไทยพร้อม workflow",
  "author": "NYC Legalization Desk",
  "publishedAt": "2026-05-26",
  "updatedAt": "2026-05-29"
 },
 {
  "slug": "moj-certified-translator-thailand-guide",
  "title": "นักแปลกระทรวงยุติธรรม (MoJ) — แปลและรับรองเอกสารศาลและกฎหมาย",
  "category": "Translation",
  "tags": [
   "MoJ",
   "นักแปลกระทรวงยุติธรรม",
   "ศาล",
   "Court Translation",
   "Legal"
  ],
  "readMinutes": 9,
  "excerpt": "เอกสารที่จะใช้ในศาลไทยหรือกระบวนการยุติธรรม ต้องแปลโดยนักแปลที่ขึ้นทะเบียนกับกระทรวงยุติธรรม (MoJ) — บทความนี้สรุปคุณสมบัติและบริการ",
  "author": "NYC Legal Translation Desk",
  "publishedAt": "2026-05-27",
  "updatedAt": "2026-05-29"
 },
 {
  "slug": "marriage-registration-by-nationality-15-countries",
  "title": "จดทะเบียนสมรสในไทย ตามสัญชาติ 15 ประเทศ — เปรียบเทียบเอกสารและขั้นตอน",
  "category": "Legal",
  "tags": [
   "จดทะเบียนสมรส",
   "Marriage",
   "Foreigner",
   "สถานทูต"
  ],
  "readMinutes": 10,
  "excerpt": "ทุกประเทศมีข้อกำหนดเอกสารต่างกันสำหรับชาวต่างชาติที่จะจดทะเบียนสมรสกับคนไทยในไทย — บทความนี้เปรียบเทียบ 15 ประเทศยอดนิยม",
  "author": "NYC Marriage Desk",
  "publishedAt": "2026-05-28",
  "updatedAt": "2026-05-29"
 },
 {
  "slug": "visa-comparison-australia-uk-us-canada-eu",
  "title": "เปรียบเทียบวีซ่าออสเตรเลีย UK USA Canada EU — สำหรับคนไทยปี 2026",
  "category": "Visa",
  "tags": [
   "Visa",
   "Australia",
   "UK",
   "USA",
   "Canada",
   "EU",
   "เปรียบเทียบวีซ่า"
  ],
  "readMinutes": 11,
  "excerpt": "อยากย้ายต่างประเทศแต่ไม่รู้เริ่มที่ไหน? บทความนี้เปรียบเทียบวีซ่าหลัก 5 ประเทศ/ภูมิภาคที่คนไทยนิยมที่สุดในปี 2026",
  "author": "NYC Visa Desk",
  "publishedAt": "2026-05-29",
  "updatedAt": "2026-05-29"
 },
 {
  "slug": "document-services-near-bts-mrt-stations",
  "title": "บริการรับรองเอกสารใกล้ BTS/MRT — Directory 60 สถานี",
  "category": "Notary",
  "tags": [
   "BTS",
   "MRT",
   "Near Me",
   "Notary",
   "Bangkok",
   "Hyperlocal"
  ],
  "readMinutes": 9,
  "excerpt": "Bangkok BTS และ MRT มีกว่า 200 สถานี — NYC ให้บริการรับ-ส่งเอกสารและ Mobile Notary ใกล้ทุกสถานี รัศมี 1 กม.",
  "author": "NYC Bangkok Team",
  "publishedAt": "2026-05-29",
  "updatedAt": "2026-05-29"
 },
 {
  "slug": "customer-stories-12-real-cases-nyc",
  "title": "12 เคสจริงจากลูกค้า NYC — ทำไมถึงเลือก NYC ครั้งแรกและกลับมาอีก",
  "category": "Legal",
  "tags": [
   "Customer Stories",
   "Case Study",
   "รีวิว",
   "ลูกค้าจริง"
  ],
  "readMinutes": 10,
  "excerpt": "บทความนี้รวบรวม 12 เคสลูกค้า NYC จากปี 2025-2026 — สถานการณ์จริง ปัญหาจริง วิธีแก้จริง พร้อมผลลัพธ์ที่ลูกค้าเห็น",
  "author": "NYC Customer Success",
  "publishedAt": "2026-05-29",
  "updatedAt": "2026-05-29"
 },
 {
  "slug": "hague-apostille-thailand-2-year-anniversary-2026",
  "title": "ครบ 2 ปี Apostille ไทย (ธ.ค. 2024 → 2026): สรุปสิ่งที่เปลี่ยน — และสิ่งที่ยังไม่เปลี่ยน",
  "category": "Legalization",
  "tags": [
   "Apostille",
   "Hague Convention",
   "MFA",
   "รับรองกงสุล",
   "Legalization"
  ],
  "readMinutes": 12,
  "excerpt": "ตั้งแต่ 15 ธันวาคม 2024 ที่ไทยเป็นภาคี Hague Apostille เต็มตัว ผ่านมา 2 ปี เคสจริงเปลี่ยนไปอย่างไร? บทความนี้สรุปสถานะปัจจุบัน 130 ประเทศสมาชิก ค่าธรรมเนียม ระยะเวลา และจุดที่ Embassy Legalization ยังจำเป็น",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-24",
  "updatedAt": "2026-06-24"
 },
 {
  "slug": "dtv-destination-thailand-visa-complete-guide-2026",
  "title": "DTV Destination Thailand Visa 2026 — คู่มือฉบับสมบูรณ์สำหรับ Digital Nomad",
  "category": "Visa",
  "tags": [
   "DTV",
   "Digital Nomad Visa",
   "วีซ่าไทย",
   "Remote Work"
  ],
  "readMinutes": 11,
  "excerpt": "DTV (Destination Thailand Visa) เปิดตัวอย่างเป็นทางการ 15 ก.ค. 2024 โดยกระทรวงการต่างประเทศและสำนักงานตรวจคนเข้าเมือง บทความนี้สรุปคุณสมบัติ 3 กลุ่ม เอกสารหลักฐานทางการเงิน ค่าธรรมเนียม และจุดที่ Digital Nomad เข้าใจผิดบ่อย",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-24",
  "updatedAt": "2026-06-24"
 },
 {
  "slug": "schengen-visa-from-thailand-2026-complete-guide",
  "title": "ขอวีซ่าเชงเกน (Schengen) จากไทย ปี 2026 — คู่มือฉบับสมบูรณ์",
  "category": "Visa",
  "tags": [
   "Schengen",
   "วีซ่ายุโรป",
   "ETIAS",
   "VFS Global",
   "TLS Contact"
  ],
  "readMinutes": 13,
  "excerpt": "ปี 2026 เขตเชงเกนขยายเป็น 29 ประเทศ (บัลแกเรีย/โรมาเนียร่วม 31 มี.ค. 2024, โครเอเชีย 1 ม.ค. 2023) ค่าธรรมเนียมขึ้นเป็น €90 ตั้งแต่ 11 มิ.ย. 2024 และระบบ ETIAS เริ่มบังคับใช้ปลายปี 2026 บทความนี้สรุปเอกสาร ขั้นตอน และกลยุทธ์เลือกประเทศยื่นที่ถูกต้องสำหรับคนไทย",
  "author": "NYC Visa Team",
  "publishedAt": "2026-06-24",
  "updatedAt": "2026-06-24"
 },
 {
  "slug": "saudi-arabia-work-visa-document-legalization-thailand-2026",
  "title": "เอกสารทำงานซาอุดีอาระเบีย 2026 — Legalization Chain ครบจบจากไทย",
  "category": "Legalization",
  "tags": [
   "Saudi Arabia",
   "Work Visa",
   "MOFA",
   "Legalization",
   "Non-Hague"
  ],
  "readMinutes": 11,
  "excerpt": "ซาอุดีอาระเบียเป็นหนึ่งในจุดหมายปลายทางการทำงานต่างประเทศที่ใหญ่ที่สุดของคนไทย แต่ไม่ได้อยู่ใน Hague Apostille Convention เอกสารทุกใบจึงต้องผ่าน Legalization Chain 5 ขั้นตอน บทความนี้สรุปขั้นตอนทุก step พร้อมค่าใช้จ่ายและระยะเวลาปี 2026",
  "author": "NYC Legalization Team",
  "publishedAt": "2026-06-24",
  "updatedAt": "2026-06-24"
 },
 {
  "slug": "apostille-japan-thailand-corridor-2026",
  "title": "Apostille ไทย→ญี่ปุ่น 2026: คู่มือฉบับสมบูรณ์ (Visa, สมรส, ทำงาน)",
  "category": "Legalization",
  "tags": [
   "apostille",
   "japan",
   "ญี่ปุ่น",
   "hague"
  ],
  "readMinutes": 11,
  "excerpt": "ตั้งแต่ 2 ม.ค. 2025 ที่ไทยเข้า Hague Convention การส่งเอกสารไป Visa/สมรส/ทำงานที่ญี่ปุ่นไม่ต้องผ่านสถานทูตญี่ปุ่นในกรุงเทพฯ อีกแล้ว — Apostille ใบเดียวจบ",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-24",
  "updatedAt": "2026-06-24"
 },
 {
  "slug": "apostille-germany-thailand-corridor-2026",
  "title": "Apostille ไทย→เยอรมนี 2026: Visa, สมรส, เรียนต่อ, ทำงาน",
  "category": "Legalization",
  "tags": [
   "apostille",
   "germany",
   "เยอรมนี",
   "anabin",
   "blue-card"
  ],
  "readMinutes": 12,
  "excerpt": "เยอรมนีเป็นปลายทาง Apostille ที่เข้มที่สุดในยุโรป เพราะ Standesamt และ Anabin ตรวจทั้งรูปแบบ Apostille และนักแปล beeidigte Übersetzer — บทความนี้แจกแจงทุกขั้น",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-24",
  "updatedAt": "2026-06-24"
 },
 {
  "slug": "apostille-korea-thailand-corridor-2026",
  "title": "Apostille ไทย→เกาหลีใต้ 2026: F-6 สมรส, E-7 ทำงาน, D-2 เรียน",
  "category": "Legalization",
  "tags": [
   "apostille",
   "korea",
   "เกาหลี",
   "f-6",
   "e-7",
   "d-2"
  ],
  "readMinutes": 12,
  "excerpt": "เกาหลีใต้เป็นสมาชิก Hague Apostille ตั้งแต่ 2007 — บทความนี้แจกแจงทุกขั้นตอนสำหรับวีซ่า F-6 (สมรส), E-7 (ทำงานเฉพาะทาง), D-2 (เรียนต่อ) ที่ลูกค้า NYC ส่งไปเกาหลีมากที่สุด",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-24",
  "updatedAt": "2026-06-24"
 },
 {
  "slug": "apostille-france-thailand-corridor-2026",
  "title": "Apostille ไทย→ฝรั่งเศส 2026: PACS, Mariage, Visa Long Séjour",
  "category": "Legalization",
  "tags": [
   "apostille",
   "france",
   "ฝรั่งเศส",
   "pacs",
   "mariage",
   "vls-ts"
  ],
  "readMinutes": 12,
  "excerpt": "ฝรั่งเศสเข้มเรื่องเอกสารราชการมาก — Mairie ตรวจทั้งรูปแบบ Apostille, อายุเอกสาร 6 เดือน, และนักแปลต้องเป็น Traducteur Assermenté ที่ Cour d'Appel ฝรั่งเศสรับรองเท่านั้น",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-24",
  "updatedAt": "2026-06-24"
 },
 {
  "slug": "apostille-uk-thailand-corridor-2026",
  "title": "Apostille ไทย→สหราชอาณาจักร 2026: Spouse Visa, Civil Partnership, Skilled Worker",
  "category": "Legalization",
  "tags": [
   "apostille",
   "uk",
   "สหราชอาณาจักร",
   "spouse-visa",
   "fcdo",
   "skilled-worker"
  ],
  "readMinutes": 13,
  "excerpt": "สหราชอาณาจักรยอมรับ e-Apostille ของไทยแล้วตั้งแต่ ม.ค. 2025 — Home Office และ HMPO ตรวจ Apostille Number ผ่าน e-Verify ของกรมการกงสุล ลดเวลาตรวจสอบ 2-3 สัปดาห์",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-25",
  "updatedAt": "2026-06-25"
 },
 {
  "slug": "apostille-canada-thailand-corridor-2026",
  "title": "Apostille ไทย→แคนาดา 2026: PR, Express Entry, IRCC ECA, Spouse Sponsorship",
  "category": "Legalization",
  "tags": [
   "apostille",
   "canada",
   "แคนาดา",
   "express-entry",
   "ircc",
   "wes",
   "spouse-sponsorship"
  ],
  "readMinutes": 13,
  "excerpt": "แคนาดาเข้าร่วม Hague Apostille Convention เมื่อ 11 ม.ค. 2024 — เอกสารไทยใช้ Apostille ใบเดียวแทน Consular Legalisation ที่สถานทูตแคนาดา ประหยัดเวลา 4-6 สัปดาห์",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-25",
  "updatedAt": "2026-06-25"
 },
 {
  "slug": "apostille-australia-thailand-corridor-2026",
  "title": "Apostille ไทย→ออสเตรเลีย 2026: Partner Visa 820/801, Skilled 189/190, NAATI",
  "category": "Legalization",
  "tags": [
   "apostille",
   "australia",
   "ออสเตรเลีย",
   "partner-visa",
   "skilled-189",
   "naati",
   "dfat"
  ],
  "readMinutes": 13,
  "excerpt": "ออสเตรเลียเป็นสมาชิก Hague Apostille ตั้งแต่ 1995 — เอกสารไทยใช้ Apostille ใบเดียว + แปลโดย NAATI Certified Translator (10-digit number) เท่านั้น Home Affairs และ DHA ตรวจ NAATI Number ผ่าน Public Search Directory",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-25",
  "updatedAt": "2026-06-25"
 },
 {
  "slug": "apostille-new-zealand-thailand-corridor-2026",
  "title": "Apostille ไทย→นิวซีแลนด์ 2026: Partner Visa, Skilled Migrant Category 6, NZQA",
  "category": "Legalization",
  "tags": [
   "apostille",
   "new-zealand",
   "นิวซีแลนด์",
   "partner-visa",
   "skilled-migrant",
   "nzqa",
   "mfat"
  ],
  "readMinutes": 12,
  "excerpt": "นิวซีแลนด์เป็นสมาชิก Hague Apostille ตั้งแต่ 2001 — Skilled Migrant Category รีเฟรชเป็นระบบ 6 คะแนน (ต.ค. 2023) ลดความซับซ้อนของ EOI ลง 80%",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-25",
  "updatedAt": "2026-06-25"
 },
 {
  "slug": "e-apostille-thailand-2026-digital-legalization",
  "title": "e-Apostille ไทย 2026 — Apostille ดิจิทัลใช้งานได้จริงหรือยัง?",
  "category": "Legalization",
  "tags": [
   "apostille",
   "e-apostille",
   "MFA",
   "Hague Convention",
   "digital"
  ],
  "readMinutes": 11,
  "excerpt": "ไทยเข้า Hague Convention เมื่อ 25 ม.ค. 2025 และเริ่มทดสอบ e-Apostille (e-APP) ในไตรมาส 2/2026 บทความนี้สรุปสิ่งที่ทำได้จริง ใช้กับประเทศไหน และข้อจำกัดที่ควรรู้",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-20",
  "updatedAt": "2026-06-27"
 },
 {
  "slug": "mrt-pink-yellow-line-area-guide-2026",
  "title": "MRT สายสีชมพู-สีเหลือง 2026 — คู่มือบริการแปล/Notary/Apostille ทุกสถานี",
  "category": "Notary",
  "tags": [
   "MRT",
   "Pink Line",
   "Yellow Line",
   "area-guide",
   "notary",
   "apostille"
  ],
  "readMinutes": 13,
  "excerpt": "MRT สายสีชมพู (30 สถานี) และสายสีเหลือง (23 สถานี) เปิดให้บริการเต็มรูปแบบในปี 2024-2025 ขยายการเข้าถึงบริการแปลและรับรองเอกสารไปยังนนทบุรี-สมุทรปราการ-มีนบุรี",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-22",
  "updatedAt": "2026-06-27"
 },
 {
  "slug": "boi-ltr-hsp-highly-skilled-professional-2026",
  "title": "BOI LTR Highly-Skilled Professional 2026 — ขั้นตอนและภาษี 17%",
  "category": "Visa",
  "tags": [
   "LTR",
   "BOI",
   "Highly-Skilled Professional",
   "Tax 17%",
   "Long-Term Resident"
  ],
  "readMinutes": 14,
  "excerpt": "LTR Visa หมวด Highly-Skilled Professional (HSP) ให้สิทธิอยู่ไทย 10 ปี + Work Permit อัตโนมัติ + ภาษีเงินได้บุคคลธรรมดา Flat 17% สำหรับผู้เชี่ยวชาญใน 10 อุตสาหกรรมเป้าหมายของ BOI",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-25",
  "updatedAt": "2026-06-27"
 },
 {
  "slug": "srt-red-line-area-guide-2026",
  "title": "SRT Red Line คู่มือพื้นที่บริการรับรองเอกสาร 2026 (บางซื่อ–รังสิต–ตลิ่งชัน)",
  "category": "Translation",
  "tags": [
   "srt-red-line",
   "bangsue",
   "rangsit",
   "taling-chan",
   "พื้นที่บริการ"
  ],
  "readMinutes": 11,
  "excerpt": "SRT Red Line เปิดให้บริการเต็มรูปแบบตั้งแต่ปี 2021 เชื่อมบางซื่อ–รังสิต (สายเหนือ) และบางซื่อ–ตลิ่งชัน (สายตะวันตก) เป็นเส้นทางที่สะดวกสำหรับลูกค้าโซนเหนือ-ตะวันตกของ กทม. ที่ต้องการเข้ามารับรองเอกสารใกล้กรมการกงสุล แจ้งวัฒนะ",
  "author": "NYC Legal Team",
  "publishedAt": "2026-07-04",
  "updatedAt": "2026-07-04"
 },
 {
  "slug": "thailand-privilege-visa-2026-complete-guide",
  "title": "Thailand Privilege Visa 2026 — คู่มือฉบับสมบูรณ์ (อดีต Thai Elite)",
  "category": "Visa",
  "tags": [
   "thailand-privilege",
   "thai-elite",
   "long-stay-visa"
  ],
  "readMinutes": 13,
  "excerpt": "Thailand Privilege Card (รีแบรนด์จาก Thai Elite ในเดือนตุลาคม 2023) เป็นโครงการ Long-Stay Visa ภายใต้ Thailand Privilege Card Co., Ltd. (TPC) ในกำกับของ ททท. มี 4 แพ็กเกจหลักที่ปรับใหม่ในปี 2024–2026",
  "author": "NYC Legal Team",
  "publishedAt": "2026-07-04",
  "updatedAt": "2026-07-04"
 },
 {
  "slug": "dtv-second-year-extension-playbook-2026",
  "title": "DTV ต่ออายุปีที่ 2 (Year-2 Extension) คู่มือ Playbook 2026",
  "category": "Visa",
  "tags": [
   "dtv",
   "destination-thailand-visa",
   "extension",
   "remote-worker"
  ],
  "readMinutes": 12,
  "excerpt": "DTV ที่เปิดตัวกรกฎาคม 2024 ครบรอบ 2 ปีในเดือนกรกฎาคม 2026 ผู้ถือ DTV รุ่นแรกหลายหมื่นคนต้องต่ออายุปีที่ 2 ซึ่ง ตม. ออกหลักเกณฑ์เพิ่มเติมเพื่อกลั่นกรองผู้ขอที่ไม่เข้าเงื่อนไขจริง",
  "author": "NYC Legal Team",
  "publishedAt": "2026-07-04",
  "updatedAt": "2026-07-04"
 },
 {
  "slug": "mfa-saraburi-chiangmai-branch-deep-dive-2026",
  "title": "MFA สาขาสระบุรี & เชียงใหม่ — Deep-Dive 2026",
  "category": "Legalization",
  "tags": [
   "mfa",
   "saraburi",
   "chiangmai",
   "consular",
   "ภูมิภาค"
  ],
  "readMinutes": 11,
  "excerpt": "กรมการกงสุล MFA เปิดสาขาภูมิภาคเพิ่ม 2 แห่งในปี 2024 ได้แก่ สระบุรี (ภาคกลาง) และเชียงใหม่ (ภาคเหนือ 8 จังหวัด) ลดภาระคิวของสาขาแจ้งวัฒนะ",
  "author": "NYC Legal Team",
  "publishedAt": "2026-07-04",
  "updatedAt": "2026-07-04"
 },
 {
  "slug": "naati-certified-translation-thailand-2026-complete-guide",
  "title": "NAATI Certified Translation ในไทย 2026 — คู่มือฉบับสมบูรณ์สำหรับยื่นวีซ่า/ย้ายถิ่นออสเตรเลีย",
  "category": "Translation",
  "tags": [
   "NAATI",
   "australia-visa",
   "PR",
   "CCL",
   "certified-translation"
  ],
  "readMinutes": 14,
  "excerpt": "ทุกอย่างที่ต้องรู้เกี่ยวกับ NAATI Certified Translation ในไทย — ตั้งแต่ Partner Visa 820/801, Skilled 189/190, จนถึง CCL Test สำหรับ Bonus 5 คะแนน PR",
  "author": "NYC Translation Bureau",
  "publishedAt": "2026-06-20",
  "updatedAt": "2026-06-27"
 },
 {
  "slug": "naati-ccl-test-prep-thailand-2026-bonus-5-points",
  "title": "NAATI CCL Test ไทย 2026 — เตรียมสอบให้ผ่านรับ +5 คะแนน PR ออสเตรเลีย",
  "category": "Translation",
  "tags": [
   "NAATI",
   "CCL",
   "PR",
   "skilled-migration",
   "australia"
  ],
  "readMinutes": 12,
  "excerpt": "ทุกอย่างที่ต้องรู้ก่อนสอบ NAATI CCL Test เพื่อรับ Bonus 5 คะแนนใน EOI Skilled Migration — Pass Rate Course NYC 73% เทียบกับมาตรฐาน 27%",
  "author": "NYC NAATI Prep Team",
  "publishedAt": "2026-06-22",
  "updatedAt": "2026-06-27"
 },
 {
  "slug": "japan-document-legalization-corridor-th-2026",
  "title": "ส่งเอกสารไทยไปญี่ปุ่น 2026 — Apostille, COE, วีซ่า F แบบครบจบ",
  "category": "Legalization",
  "tags": [
   "japan",
   "apostille",
   "coe",
   "วีซ่าญี่ปุ่น",
   "legalization"
  ],
  "readMinutes": 10,
  "excerpt": "ญี่ปุ่นเป็นภาคี Hague Apostille ตั้งแต่ปี 1970 หลังไทยเข้าภาคี (25 ม.ค. 2025) เอกสารไทยใช้ในญี่ปุ่นได้โดย Apostille เพียงชั้นเดียว ไม่ต้องผ่านสถานทูตญี่ปุ่นอีก",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "south-korea-document-legalization-corridor-th-2026",
  "title": "ส่งเอกสารไทยไปเกาหลีใต้ 2026 — Apostille + Hi Korea + วีซ่า F",
  "category": "Legalization",
  "tags": [
   "korea",
   "apostille",
   "hi-korea",
   "วีซ่าเกาหลี",
   "legalization"
  ],
  "readMinutes": 10,
  "excerpt": "เกาหลีใต้เป็นภาคี Hague Apostille ตั้งแต่ปี 2007 หลังไทยเข้าภาคีเมื่อ 25 ม.ค. 2025 เอกสารไทยใช้ในเกาหลีได้โดย Apostille ชั้นเดียว แต่ Hi Korea มีกฎ 3 เดือนที่ต้องระวัง",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "gcc-embassy-legalisation-thailand-th-2026",
  "title": "รับรองสถานทูต GCC 2026 — UAE / Saudi / Kuwait / Qatar / Bahrain / Oman",
  "category": "Legalization",
  "tags": [
   "gcc",
   "uae",
   "saudi",
   "kuwait",
   "qatar",
   "embassy-legalisation"
  ],
  "readMinutes": 11,
  "excerpt": "GCC ทั้ง 6 ประเทศ (UAE, Saudi Arabia, Kuwait, Qatar, Bahrain, Oman) ยังไม่เข้าภาคี Hague Apostille — ต้องผ่าน MFA + Embassy + MOFA ปลายทาง 3 ชั้นตามเดิม",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "india-document-legalization-corridor-th-2026",
  "title": "รับรองเอกสารไทยใช้ในอินเดีย 2026 — Apostille หลังอินเดียเข้า Hague",
  "category": "Legalization",
  "tags": [
   "india",
   "apostille",
   "MEA",
   "OCI",
   "legalization"
  ],
  "readMinutes": 10,
  "excerpt": "อินเดียเป็นภาคี Hague Apostille ตั้งแต่ปี 2005 — เอกสารไทยที่จะใช้ในอินเดีย (วีซ่า OCI, ทำงาน X-1/E, จดทะเบียนสมรส, เปิดบริษัท) สามารถใช้ Apostille ชั้นเดียวได้แล้ว",
  "author": "NYC Legal Editorial Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "taiwan-document-legalization-corridor-th-2026",
  "title": "รับรองเอกสารไทยใช้ในไต้หวัน 2026 — TECO Bangkok ฉบับครบจบ",
  "category": "Legalization",
  "tags": [
   "taiwan",
   "TECO",
   "legalization",
   "gold-card",
   "marriage-abroad"
  ],
  "readMinutes": 10,
  "excerpt": "ไต้หวันไม่ใช่ภาคี Hague Apostille — เอกสารไทยที่ใช้ในไต้หวันยังต้องผ่าน MFA + TECO Bangkok + MOFA Taipei แบบ 3 ชั้นตามเดิม",
  "author": "NYC Legal Editorial Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "germany-document-legalization-corridor-th-2026",
  "title": "รับรองเอกสารใช้ในเยอรมนี 2026 — Apostille + Sworn Translator คู่มือฉบับสมบูรณ์",
  "category": "Legalization",
  "tags": [
   "เยอรมนี",
   "apostille",
   "standesamt",
   "zab",
   "sworn-translator"
  ],
  "readMinutes": 11,
  "excerpt": "ตั้งแต่ 28 ก.พ. 2570 (ไทยเข้า Hague) สถานทูตเยอรมัน กทม. ไม่รับรองเอกสารไทยอีกแล้ว — ใช้ MFA Apostille + sworn translator ที่ขึ้นทะเบียน Landgericht เท่านั้น NYC ปิดเคสจดทะเบียนสมรส Standesamt ใน 9–12 วันทำการ",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "china-document-legalization-corridor-th-2026",
  "title": "รับรองเอกสารใช้ในจีน 2026 — หลังจีนเข้า Hague (พ.ย. 2023) คู่มือฉบับสมบูรณ์",
  "category": "Legalization",
  "tags": [
   "จีน",
   "apostille",
   "z-visa",
   "公证处",
   "residence-permit"
  ],
  "readMinutes": 11,
  "excerpt": "จีนเข้า Hague Apostille มีผล 7 พ.ย. 2023 และไทยมีผล 28 ก.พ. 2570 — สถานทูตจีน กทม. ไม่รับรองเอกสารไทยส่วนใหญ่อีกแล้ว NYC ปิดชุด Z-visa ใน 6–9 วันทำการ",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "france-document-legalization-corridor-th-2026",
  "title": "ระเบียงเอกสารไทย–ฝรั่งเศส 2026: Apostille, Traducteur Assermenté, OFII, Mairie จดทะเบียนสมรส",
  "category": "Legalization",
  "tags": [
   "france",
   "apostille",
   "ofii",
   "mairie",
   "traducteur-assermente"
  ],
  "readMinutes": 11,
  "excerpt": "ฝรั่งเศสเป็นภาคี Hague ตั้งแต่ 1965 ไทยมีผล 28 ก.พ. 2570 — สถานทูตฝรั่งเศส กทม. หยุดรับรองแล้ว แต่คำแปลต้องทำใหม่ในฝรั่งเศสโดยนักแปลสาบานเท่านั้น",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "italy-document-legalization-corridor-th-2026",
  "title": "ระเบียงเอกสารไทย–อิตาลี 2026: Apostille, Dichiarazione di Valore, CIMEA, Comune จดทะเบียนสมรส",
  "category": "Legalization",
  "tags": [
   "italy",
   "apostille",
   "dichiarazione-di-valore",
   "cimea",
   "comune"
  ],
  "readMinutes": 11,
  "excerpt": "Apostille แทน Legalizzazione ที่สถานทูตอิตาลี กทม. ตั้งแต่ 28 ก.พ. 2570 — แต่ Dichiarazione di Valore ยังจำเป็นสำหรับสมัครมหาวิทยาลัย CIMEA เป็นทางเลือกออนไลน์ €170",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "australia-document-legalization-corridor-th-2026",
  "title": "ระเบียงเอกสารไทย–ออสเตรเลีย 2026: MFA Apostille, NAATI Certified, AHPRA, VETASSESS",
  "category": "Legalization",
  "tags": [
   "australia",
   "apostille",
   "naati",
   "ahpra",
   "vetassess"
  ],
  "readMinutes": 11,
  "excerpt": "ออสเตรเลียรับ MFA Apostille ไทยตรง แต่ทุกเอกสารต้องแปลโดย NAATI Certified Translator ที่มี CPN ปัจจุบัน NYC ออก NAATI + Apostille ในกระบวนการเดียว",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "spain-document-legalization-corridor-th-2026",
  "title": "เส้นทางรับรองเอกสารไทย→สเปน 2026: Apostille MFA, Traductor Jurado, NIE และ Registro Civil",
  "category": "Legalization",
  "tags": [
   "spain",
   "apostille",
   "traductor-jurado",
   "nie",
   "homologacion"
  ],
  "readMinutes": 11,
  "excerpt": "สเปนเข้าร่วม Hague Apostille ตั้งแต่ปี 1978 หลังไทยภาคยานุวัติ 28 ก.พ. 2570 สถานทูตสเปนกรุงเทพหยุดรับรองเอกสารไทย คำแปลทุกฉบับต้องทำโดย Traductor Jurado ในสเปน",
  "author": "ทีมกฎหมาย NYC",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "uk-document-legalization-corridor-th-2026",
  "title": "เส้นทางรับรองเอกสารไทย→UK 2026: Apostille MFA, Home Office, NMC, GMC, ECCTR",
  "category": "Legalization",
  "tags": [
   "uk",
   "apostille",
   "home-office",
   "nmc",
   "gmc"
  ],
  "readMinutes": 11,
  "excerpt": "สหราชอาณาจักรรับ Apostille ไทยตรงสำหรับทุกการยื่น Home Office, NMC, GMC, Ecctis, GRO สถานทูตอังกฤษกรุงเทพหยุดรับรองเอกสารไทยตั้งแต่ 28 ก.พ. 2570",
  "author": "ทีมกฎหมาย NYC",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "uae-document-legalization-corridor-th-2026",
  "title": "เส้นทางรับรองเอกสารไทย→UAE 2026: Triple Chain MFA + UAE Embassy Bangkok + MOFAIC Abu Dhabi",
  "category": "Legalization",
  "tags": [
   "uae",
   "embassy-legalization",
   "mofaic",
   "arabic-translation",
   "mohre"
  ],
  "readMinutes": 12,
  "excerpt": "UAE ไม่ใช่สมาชิก Hague Apostille เอกสารไทยยังต้องเดิน triple chain เต็ม: MFA กรุงเทพ → สถานทูต UAE กรุงเทพ → MOFAIC Abu Dhabi/Dubai ตามด้วยคำแปล Arabic โดยนักแปล Ministry of Justice ใน UAE",
  "author": "ทีมกฎหมาย NYC",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "canada-document-legalization-corridor-th-2026",
  "title": "เส้นทางรับรองเอกสารแคนาดา 2026: MFA Apostille ไทย, IRCC, WES, NNAS, MCC, OTTIAQ Quebec",
  "category": "Legalization",
  "tags": [
   "canada",
   "apostille",
   "ircc",
   "wes",
   "quebec"
  ],
  "readMinutes": 11,
  "excerpt": "แคนาดาเข้าร่วม Hague Apostille มีผล 11 ม.ค. 2024 ก่อนไทย 18 เดือน Apostille ของ MFA ไทยใช้กับ IRCC, WES, NNAS, MCC, ICAS และนายทะเบียนทุกมณฑลโดยตรง สถานทูตแคนาดากรุงเทพหยุดรับรองเอกสารไทยตั้งแต่ 28 ก.พ. 2570",
  "author": "ทีมกฎหมาย NYC",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "switzerland-document-legalization-corridor-th-2026",
  "title": "เส้นทางรับรองเอกสารสวิตเซอร์แลนด์ 2026: MFA Apostille, SEM, Zivilstandsamt, FMH, นักแปลสาบานระดับ canton",
  "category": "Legalization",
  "tags": [
   "switzerland",
   "apostille",
   "sem",
   "fmh",
   "zivilstandsamt"
  ],
  "readMinutes": 11,
  "excerpt": "สวิตเซอร์แลนด์เป็นภาคี Hague ตั้งแต่ 1973 — เร็วที่สุดในยุโรปภาคพื้นทวีป MFA Apostille ไทยใช้ตรงกับ SEM, สำนักตรวจคนเข้าเมืองทุก canton, Zivilstandsamt จดสมรส, FMH แพทย์ และ Swissmedic เภสัช",
  "author": "ทีมกฎหมาย NYC",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "netherlands-document-legalization-corridor-th-2026",
  "title": "เส้นทางรับรองเอกสารเนเธอร์แลนด์ 2026: MFA Apostille, IND, Gemeente, BIG-register, Nuffic, beëdigd vertaler",
  "category": "Legalization",
  "tags": [
   "netherlands",
   "apostille",
   "ind",
   "big-register",
   "nuffic"
  ],
  "readMinutes": 10,
  "excerpt": "เนเธอร์แลนด์เป็นภาคี Hague ตั้งแต่ 1965 MFA Apostille ไทยใช้ตรงกับ IND, Gemeente ทุกแห่งสำหรับลงทะเบียน BRP, BIG-register สาธารณสุข, Nuffic ประเมินวุฒิ และ Rechtbank กำกับนักแปลสาบาน สถานทูตเนเธอร์แลนด์กรุงเทพหยุดรับรองเอกสารไทย 28 ก.พ. 2570",
  "author": "ทีมกฎหมาย NYC",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "sweden-document-legalization-corridor-th-2026",
  "title": "เส้นทางรับรองเอกสารสวีเดน 2026: MFA Apostille, Migrationsverket, Skatteverket, UHR, Socialstyrelsen, คำแปล Kammarkollegiet",
  "category": "Legalization",
  "tags": [
   "sweden",
   "apostille",
   "migrationsverket",
   "uhr",
   "socialstyrelsen"
  ],
  "readMinutes": 11,
  "excerpt": "สวีเดนเป็นภาคี Hague ตั้งแต่ 1999 MFA Apostille ไทยใช้ตรงกับ Migrationsverket, Skatteverket สำหรับ folkbokföring, UHR ประเมินวุฒิ, Socialstyrelsen ขึ้นทะเบียนวิชาชีพแพทย์ และ tingsrätt ทุกแห่ง สถานทูตสวีเดนกรุงเทพหยุดรับรองเอกสารไทย 28 ก.พ. 2570",
  "author": "ทีมกฎหมาย NYC",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "norway-document-legalization-corridor-th-2026",
  "title": "เส้นทางรับรองเอกสารนอร์เวย์ 2026: MFA Apostille, UDI, Skatteetaten, NOKUT, Helsedirektoratet, statsautorisert translatør",
  "category": "Legalization",
  "tags": [
   "norway",
   "apostille",
   "udi",
   "nokut",
   "helsedirektoratet"
  ],
  "readMinutes": 11,
  "excerpt": "นอร์เวย์เป็นภาคี Hague ตั้งแต่ 1983 MFA Apostille ไทยใช้ตรงกับ UDI, Skatteetaten สำหรับ folkeregister, NOKUT ประเมินวุฒิ, Helsedirektoratet และ tingrett ทุกแห่ง สถานทูตนอร์เวย์กรุงเทพหยุดรับรองเอกสารไทย 28 ก.พ. 2570",
  "author": "ทีมกฎหมาย NYC",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "denmark-document-legalization-corridor-th-2026",
  "title": "เส้นทางรับรองเอกสารเดนมาร์ก 2026: MFA Apostille, SIRI, Familieretshuset, Patientsikkerhed, UFM, คำแปลมืออาชีพ",
  "category": "Legalization",
  "tags": [
   "denmark",
   "apostille",
   "siri",
   "ufm",
   "patientsikkerhed"
  ],
  "readMinutes": 10,
  "excerpt": "เดนมาร์กเป็นภาคี Hague ตั้งแต่ 2006 และไทยมีผล 28 ก.พ. 2570 MFA Apostille ไทยใช้ตรงกับ SIRI, Familieretshuset, Styrelsen for Patientsikkerhed, UFM และ byret ทุกแห่ง ต่างจาก Nordic อื่น เดนมาร์กยกเลิกผูกขาดนักแปลสาบาน 2016 — รับคำแปลพร้อม declaration นักแปลมืออาชีพ",
  "author": "ทีมกฎหมาย NYC",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "belgium-document-legalization-corridor-th-2026",
  "title": "เส้นทางรับรองเอกสารเบลเยียม 2026: MFA Apostille, Office des Étrangers/DVZ, commune/gemeente, INAMI/RIZIV, NARIC, traducteur juré/beëdigd vertaler",
  "category": "Legalization",
  "tags": [
   "belgium",
   "apostille",
   "office-des-etrangers",
   "inami",
   "naric"
  ],
  "readMinutes": 11,
  "excerpt": "เบลเยียมเป็นภาคี Hague ตั้งแต่ 1976 MFA Apostille ไทยใช้ตรงกับ Office des Étrangers/DVZ, commune/gemeente ทุกแห่งจดทะเบียนแพ่ง, INAMI/RIZIV ขึ้นทะเบียนสาธารณสุข, NARIC-Vlaanderen และ ENIC-Naric Wallonia ประเมินวุฒิ และ tribunal de première instance ทุกแห่ง สถานทูตเบลเยียมกรุงเทพหยุดรับรองเอกสารไทย 28 ก.พ. 2570",
  "author": "ทีมกฎหมาย NYC",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "naati-uk-us-canada-acceptance-th-2026",
  "title": "NAATI ใช้ที่ UK / US / Canada ได้หรือไม่? คู่มือ 2026 (ATA, CTTIC, ITI/CIOL)",
  "category": "Translation",
  "tags": [
   "naati",
   "ata",
   "cttic",
   "iti",
   "uscis",
   "ircc",
   "ukvi"
  ],
  "readMinutes": 10,
  "excerpt": "NAATI ออสเตรเลียได้รับการยอมรับในออสเตรเลียและนิวซีแลนด์เท่านั้น สำหรับ USCIS, IRCC, UKVI ใช้ ATA / CTTIC / ITI หรือ MFA Apostille + sworn translation ของประเทศปลายทาง",
  "author": "ทีมแปล NYC",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "vietnam-document-legalization-corridor-th-2026",
  "title": "เส้นทางรับรองเอกสารไทย → เวียดนาม 2026 (Non-Hague + สถานทูตเวียดนาม กทม.)",
  "category": "Legalization",
  "tags": [
   "vietnam",
   "embassy",
   "legalization",
   "trc",
   "work-permit"
  ],
  "readMinutes": 9,
  "excerpt": "เวียดนามไม่ใช่สมาชิก Hague Apostille — เอกสารไทยต้องผ่าน MFA + สถานทูตเวียดนามกรุงเทพ + Cục Lãnh sự ก่อนใช้ที่ Sở Tư pháp/Sở Lao động",
  "author": "ทีมเอกสาร NYC",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "indonesia-document-legalization-corridor-th-2026",
  "title": "เส้นทางรับรองเอกสารไทย → อินโดนีเซีย 2026 (Hague Apostille ตั้งแต่ มิ.ย. 2022)",
  "category": "Legalization",
  "tags": [
   "indonesia",
   "apostille",
   "kitas",
   "imta",
   "disdukcapil"
  ],
  "readMinutes": 8,
  "excerpt": "อินโดนีเซียเป็นภาคี Hague Apostille ตั้งแต่ 4 มิ.ย. 2022 และไทยเข้า 28 ก.พ. 2570 — เอกสารไทยใช้ Apostille ตรงในอินโดนีเซีย ไม่ต้องผ่านสถานทูต KBRI",
  "author": "ทีมเอกสาร NYC",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "philippines-document-legalization-corridor-th-2026",
  "title": "เส้นทางรับรองเอกสารไทย → ฟิลิปปินส์ 2026 (Hague Apostille ตั้งแต่ พ.ค. 2019)",
  "category": "Legalization",
  "tags": [
   "philippines",
   "apostille",
   "acr-icard",
   "aep",
   "ched",
   "psa"
  ],
  "readMinutes": 8,
  "excerpt": "ฟิลิปปินส์เป็นภาคี Hague ตั้งแต่ 14 พ.ค. 2019 และไทยเข้า 28 ก.พ. 2570 — เอกสารไทยใช้ Apostille ตรงสำหรับ BI, DOLE, PSA, CHED, PRC ไม่ต้องผ่านสถานทูต",
  "author": "ทีมเอกสาร NYC",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "malaysia-document-legalization-corridor-th-2026",
  "title": "เส้นทางรับรองเอกสารไทย → มาเลเซีย 2026 (Non-Hague + High Commission Bangkok)",
  "category": "Legalization",
  "tags": [
   "malaysia",
   "embassy",
   "ep-pass",
   "mm2h",
   "jpn",
   "wisma-putra"
  ],
  "readMinutes": 9,
  "excerpt": "มาเลเซียไม่ใช่ภาคี Hague — เอกสารไทยยังต้องผ่าน chain เต็ม MFA + High Commission of Malaysia Bangkok + Wisma Putra Putrajaya สำหรับ EP, DP, MM2H",
  "author": "ทีมเอกสาร NYC",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "sri-lanka-document-legalization-corridor-th-2026",
  "title": "เอกสารไทย → ศรีลังกา 2026: Apostille ใช้ได้เต็มที่หลัง 5 ม.ค. 2025",
  "category": "Legalization",
  "tags": [
   "sri-lanka",
   "apostille",
   "ugc",
   "registrar-general",
   "immigration-lk"
  ],
  "readMinutes": 9,
  "excerpt": "ศรีลังกาเข้า Hague Apostille มีผล 5 ม.ค. 2025 และไทยเข้า 28 ก.พ. 2570 — เอกสารไทยใช้ Apostille MFA อย่างเดียวกับ Department of Immigration & Emigration, Registrar General Department และ University Grants Commission ไม่ต้องผ่านสถานทูตศรีลังกา Bangkok อีกต่อไป",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "bangladesh-document-legalization-corridor-th-2026",
  "title": "เอกสารไทย → บังคลาเทศ 2026: BIDA, Bangladesh Bank, Registrar Office",
  "category": "Legalization",
  "tags": [
   "bangladesh",
   "embassy",
   "bida",
   "work-permit-bd",
   "mofa-dhaka"
  ],
  "readMinutes": 9,
  "excerpt": "บังคลาเทศยังไม่เข้า Hague Apostille — เอกสารไทยต้องเดิน chain MFA + Embassy of Bangladesh Bangkok (ทองหล่อ) + MOFA Dhaka ก่อนใช้กับ BIDA, Bangladesh Bank, Registrar Office",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "pakistan-document-legalization-corridor-th-2026",
  "title": "เอกสารไทย → ปากีสถาน 2026: NADRA, FIA, MOFA Islamabad",
  "category": "Legalization",
  "tags": [
   "pakistan",
   "embassy",
   "nadra",
   "fia",
   "mofa-islamabad",
   "muslim-family-laws"
  ],
  "readMinutes": 9,
  "excerpt": "ปากีสถานยังไม่เข้า Hague Apostille — เอกสารไทยต้องเดิน chain MFA + Embassy of Pakistan Bangkok (สุขุมวิท 31) + MOFA Islamabad ก่อนใช้กับ NADRA, FIA, BISP หรือ Board of Revenue",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "nepal-document-legalization-corridor-th-2026",
  "title": "เอกสารไทย → เนปาล 2026: DAO Marriage, CRO Company, Immigration",
  "category": "Legalization",
  "tags": [
   "nepal",
   "embassy",
   "cro-nepal",
   "dao",
   "mofa-kathmandu",
   "singha-durbar"
  ],
  "readMinutes": 9,
  "excerpt": "เนปาลยังไม่เข้า Hague Apostille — เอกสารไทยต้องเดิน chain MFA + Embassy of Nepal Bangkok (สุขุมวิท 23) + MOFA Kathmandu (Singha Durbar) ก่อนใช้กับ Department of Immigration, CRO และ DAO สำหรับสมรส",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "brazil-document-legalization-corridor-th-2026",
  "title": "เอกสารไทย → บราซิล 2026: Apostille, Cartório, Receita Federal",
  "category": "Legalization",
  "tags": [
   "brazil",
   "apostille",
   "cartorio",
   "receita-federal",
   "tradutor-juramentado"
  ],
  "readMinutes": 9,
  "excerpt": "บราซิลเข้า Hague Apostille ตั้งแต่ ส.ค. 2016 — เอกสารไทย Apostille MFA ใช้กับ Receita Federal, Cartório, Polícia Federal, Junta Comercial โดยตรง สถานทูตบราซิลในกรุงเทพหยุดรับ legalisation แล้ว",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-29",
  "updatedAt": "2026-06-29"
 },
 {
  "slug": "mexico-document-legalization-corridor-th-2026",
  "title": "เอกสารไทย → เม็กซิโก 2026: Apostille, INM, Registro Civil, SAT",
  "category": "Legalization",
  "tags": [
   "mexico",
   "apostille",
   "inm",
   "registro-civil",
   "perito-traductor"
  ],
  "readMinutes": 9,
  "excerpt": "เม็กซิโกเข้า Hague Apostille ตั้งแต่ 14 ส.ค. 1995 — เอกสารไทย Apostille MFA ใช้กับ INM (immigration), Registro Civil, SAT (tax) และ Notario Público ของ 32 รัฐได้โดยตรง",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-29",
  "updatedAt": "2026-06-29"
 },
 {
  "slug": "south-africa-document-legalization-corridor-th-2026",
  "title": "เอกสารไทย → แอฟริกาใต้ 2026: Apostille, Home Affairs, CIPC",
  "category": "Legalization",
  "tags": [
   "south-africa",
   "apostille",
   "home-affairs",
   "cipc",
   "dirco"
  ],
  "readMinutes": 8,
  "excerpt": "แอฟริกาใต้เข้า Hague Apostille ตั้งแต่ 30 เม.ย. 1995 — เอกสารไทย Apostille MFA ใช้กับ Department of Home Affairs (visa), CIPC (company), DIRCO และ SARS ได้โดยตรง",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-29",
  "updatedAt": "2026-06-29"
 },
 {
  "slug": "egypt-document-legalization-corridor-th-2026",
  "title": "เอกสารไทย → อียิปต์ 2026: MFA + Embassy + MOFA Cairo",
  "category": "Legalization",
  "tags": [
   "egypt",
   "embassy",
   "gafi",
   "mofa-cairo",
   "personal-status-court"
  ],
  "readMinutes": 9,
  "excerpt": "อียิปต์ยังไม่เข้า Hague Apostille — เอกสารไทยต้องเดิน chain MFA + Embassy of Egypt Bangkok (ทองหล่อ ซอย 10) + MOFA Cairo (Tahrir) ก่อนใช้กับ GAFI, Notary Public Egypt, Personal Status Court",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-29",
  "updatedAt": "2026-06-29"
 },
 {
  "slug": "nigeria-document-legalization-corridor-th-2026",
  "title": "เอกสารไทย → ไนจีเรีย 2026: MFA + Embassy + MOFA Abuja",
  "category": "Legalization",
  "tags": [
   "nigeria",
   "embassy",
   "cac",
   "mofa-abuja",
   "nis"
  ],
  "readMinutes": 8,
  "excerpt": "ไนจีเรียยังไม่เข้า Hague Apostille — เอกสารไทยต้องเดิน chain MFA + Embassy of Nigeria Bangkok (สาทร) + MOFA Abuja ก่อนใช้กับ CAC, NIS, Federal High Court",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-29",
  "updatedAt": "2026-06-29"
 },
 {
  "slug": "kenya-document-legalization-corridor-th-2026",
  "title": "เอกสารไทย → เคนยา 2026: Apostille Hague Direct",
  "category": "Legalization",
  "tags": [
   "kenya",
   "apostille",
   "ecitizen",
   "kra",
   "hague-2025"
  ],
  "readMinutes": 8,
  "excerpt": "เคนยาเข้า Hague Apostille Convention วันที่ 14 ม.ค. 2025 — เอกสารไทยที่มี Apostille MFA ใช้ได้โดยตรงกับ eCitizen, KRA, Registrar of Companies ไม่ต้องผ่านสถานทูตเคนยา",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-29",
  "updatedAt": "2026-06-29"
 },
 {
  "slug": "argentina-document-legalization-corridor-th-2026",
  "title": "เอกสารไทย → อาร์เจนตินา 2026: Apostille Direct + Tradutor",
  "category": "Legalization",
  "tags": [
   "argentina",
   "apostille",
   "registro-civil",
   "afip",
   "igj"
  ],
  "readMinutes": 8,
  "excerpt": "อาร์เจนตินาเข้า Hague Apostille Convention ตั้งแต่ 18 ก.พ. 1988 — เอกสารไทย Apostille MFA ใช้ตรงกับ Registro Civil, AFIP, IGJ ต้องแปล Spanish โดย Traductor Público Juramentado ขึ้นทะเบียน CTPCBA",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-29",
  "updatedAt": "2026-06-29"
 },
 {
  "slug": "chile-document-legalization-corridor-th-2026",
  "title": "เอกสารไทย → ชิลี 2026: Apostille Direct + Traductor Oficial",
  "category": "Legalization",
  "tags": [
   "chile",
   "apostille",
   "registro-civil",
   "sii",
   "cbr"
  ],
  "readMinutes": 8,
  "excerpt": "ชิลีเข้า Hague Apostille Convention ตั้งแต่ 30 ส.ค. 2016 — เอกสารไทย Apostille MFA ใช้ตรงกับ Registro Civil, SII, CBR ต้องแปล Spanish โดย Traductor Oficial ขึ้นทะเบียน Ministerio de Relaciones Exteriores",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-29",
  "updatedAt": "2026-06-29"
 },
 {
  "slug": "russia-document-legalization-corridor-th-2026",
  "title": "เอกสารไทย → รัสเซีย 2026: Apostille + Notary Rossii",
  "category": "Legalization",
  "tags": [
   "russia",
   "apostille",
   "zags",
   "rosreestr",
   "notariat"
  ],
  "readMinutes": 9,
  "excerpt": "Российская Федерация เข้า Hague Apostille ตั้งแต่ 31 พ.ค. 1992 (สืบทอดจาก USSR) — Apostille MFA Thailand ใช้ได้ตรงกับ ZAGS (สมรส/เกิด), Rosreestr (อสังหา), FNS (INN tax ID), Notariat แต่บังคับแปล Russian โดย Sworn Translator ในรัสเซีย + Notary Rossii รับรองลายเซ็นนักแปลภายใต้ Основы законодательства РФ о нотариате 4462-1/1993",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-30",
  "updatedAt": "2026-06-30"
 },
 {
  "slug": "turkey-document-legalization-corridor-th-2026",
  "title": "เอกสารไทย → ตุรกี 2026: Apostille + Yeminli Tercüman + Noter",
  "category": "Legalization",
  "tags": [
   "turkey",
   "apostille",
   "nufus",
   "tapu",
   "yeminli-tercuman"
  ],
  "readMinutes": 9,
  "excerpt": "Türkiye Cumhuriyeti เข้า Hague Apostille ตั้งแต่ 29 ก.ย. 1985 — Apostille MFA Thailand ใช้ตรงกับ Nüfus ve Vatandaşlık (สมรส/เกิด/ID), Tapu Sicil (อสังหา), MERSİS (บริษัท), Noter ทั่วประเทศ บังคับแปล Türkçe โดย Yeminli Tercüman + Noter Tasdiki ตาม Noterlik Kanunu 1512/1972",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-30",
  "updatedAt": "2026-06-30"
 },
 {
  "slug": "israel-document-legalization-corridor-th-2026",
  "title": "เอกสารไทย → อิสราเอล 2026: Apostille + Notary Israel",
  "category": "Legalization",
  "tags": [
   "israel",
   "apostille",
   "misrad-hapnim",
   "rabbinical-court",
   "tabu"
  ],
  "readMinutes": 9,
  "excerpt": "מדינת ישראל เข้า Hague Apostille ตั้งแต่ 14 ส.ค. 1978 — Apostille MFA Thailand ใช้ได้ตรงกับ Misrad Hapnim (Interior Ministry), Tabu (Land Registry), Rashut HaOchlosin (Population & Immigration), Rabbinical Court แต่บังคับแปล Hebrew + Notary Israel ตาม Notaries Law 5736-1976",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-30",
  "updatedAt": "2026-06-30"
 },
 {
  "slug": "saudi-arabia-document-legalization-corridor-th-2026",
  "title": "เอกสารไทย → ซาอุดีอาระเบีย 2026: MOFA + SADAD + Tasdeeq",
  "category": "Legalization",
  "tags": [
   "saudi-arabia",
   "embassy",
   "tasdeeq",
   "qiwa",
   "vision-2030"
  ],
  "readMinutes": 9,
  "excerpt": "المملكة العربية السعودية ยังไม่เข้า Hague Apostille — เอกสารไทยต้องเดิน chain MFA + Embassy of Saudi Arabia Bangkok (สาทร 12) + Tasdeeq MOFA Riyadh ก่อนใช้กับ MOL Qiwa, MOJ Najiz, Absher, MOH (Iqama, Family Visit, Work Permit) ภายใต้ Vision 2030 reforms",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-30",
  "updatedAt": "2026-06-30"
 },
 {
  "slug": "iran-document-legalization-corridor-th-2026",
  "title": "เอกสารไทย → อิหร่าน 2026: MFA + Embassy + MOFA Tehran",
  "category": "Legalization",
  "tags": [
   "iran",
   "embassy",
   "tasdiq",
   "mahzar",
   "non-hague"
  ],
  "readMinutes": 8,
  "excerpt": "جمهوری اسلامی ایران ยังไม่เข้า Hague Apostille — เอกสารไทยต้องเดิน chain MFA + Embassy of Iran Bangkok + Tasdiq MOFA Tehran ก่อนใช้กับ Sazman-e Sabt-e Ahval (Civil Registry), Mahzar (Notary Public), NAJA, Sazman-e Sabt-e Asnad (Deeds Registry) ภายใต้ Civil Code 1928 และ Notaries Law 1316/1937",
  "author": "NYC Document Team",
  "publishedAt": "2026-07-01",
  "updatedAt": "2026-07-01"
 },
 {
  "slug": "iraq-document-legalization-corridor-th-2026",
  "title": "เอกสารไทย → อิรัก 2026: MFA + Embassy + MOFA Baghdad",
  "category": "Legalization",
  "tags": [
   "iraq",
   "embassy",
   "tasdiq",
   "baghdad",
   "non-hague"
  ],
  "readMinutes": 8,
  "excerpt": "جمهورية العراق ยังไม่เข้า Hague Apostille — เอกสารไทยต้องเดิน chain MFA + Embassy of Iraq Bangkok + Tasdiq MOFA Baghdad (Green Zone, Authentication Department) ก่อนใช้กับ Da'irat Al-Ahwal Al-Madaniya (Civil Status), Catasta (Land Registry), Ministry of Labour, Ministry of Health, Ministry of Higher Education ภายใต้ Civil Code 40/1951 + Personal Status Law 188/1959",
  "author": "NYC Document Team",
  "publishedAt": "2026-07-01",
  "updatedAt": "2026-07-01"
 },
 {
  "slug": "jordan-document-legalization-corridor-th-2026",
  "title": "เอกสารไทย → จอร์แดน 2026: MFA + Embassy + MOFA Amman",
  "category": "Legalization",
  "tags": [
   "jordan",
   "embassy",
   "tasdiq",
   "amman",
   "non-hague"
  ],
  "readMinutes": 8,
  "excerpt": "المملكة الأردنية الهاشمية ยังไม่เข้า Hague Apostille — เอกสารไทยต้อง chain MFA + Embassy of Jordan Bangkok + Tasdiq MOFA Amman (4th Circle, Department of Authentication) ก่อนใช้กับ Da'irat Al-Ahwal Al-Madaniya wa Al-Jawazat, Ministry of Labour (Tasreeh Amal), Sharia Court, Department of Lands and Survey ภายใต้ Civil Code 43/1976 + Personal Status Law 36/2010",
  "author": "NYC Document Team",
  "publishedAt": "2026-07-01",
  "updatedAt": "2026-07-01"
 },
 {
  "slug": "lebanon-document-legalization-corridor-th-2026",
  "title": "เอกสารไทย → เลบานอน 2026: MFA + Embassy + MOFA Beirut",
  "category": "Legalization",
  "tags": [
   "lebanon",
   "embassy",
   "tasdiq",
   "beirut",
   "non-hague"
  ],
  "readMinutes": 8,
  "excerpt": "الجمهورية اللبنانية ยังไม่เข้า Hague Apostille — เอกสารไทยต้อง chain MFA + Embassy of Lebanon Bangkok + Tasdiq MOFA Beirut (Achrafieh) + ศาล Personal Status ตาม 18 นิกาย (Maronite, Sunni, Shia, Druze, etc.) ภายใต้ Decree 60/L.R. 1936",
  "author": "NYC Document Team",
  "publishedAt": "2026-07-01",
  "updatedAt": "2026-07-01"
 },
 {
  "slug": "qatar-document-legalization-corridor-th-2026",
  "title": "เอกสารไทย → กาตาร์ 2026: MFA + Embassy + MOFA Doha",
  "category": "Legalization",
  "tags": [
   "qatar",
   "embassy",
   "tasdiq",
   "doha",
   "non-hague",
   "gcc"
  ],
  "readMinutes": 8,
  "excerpt": "دولة قطر ยังไม่เข้า Hague Apostille — เอกสารไทยต้อง chain MFA + Embassy of Qatar Bangkok + Tasdiq MOFA Doha (Authentication Department) ก่อนใช้กับ Ministry of Interior (Metrash2/Hukoomi), MADLSA, MOPH DHP, Sharia Court, QFC ภายใต้ Civil Code 22/2004 + Family Law 22/2006",
  "author": "NYC Document Team",
  "publishedAt": "2026-07-15",
  "updatedAt": "2026-07-15"
 },
 {
  "slug": "kuwait-document-legalization-corridor-th-2026",
  "title": "เอกสารไทย → คูเวต 2026: MFA + Embassy + MOFA Kuwait City",
  "category": "Legalization",
  "tags": [
   "kuwait",
   "embassy",
   "tasdiq",
   "non-hague",
   "gcc"
  ],
  "readMinutes": 8,
  "excerpt": "دولة الكويت ยังไม่เข้า Hague Apostille — เอกสารไทยต้อง chain MFA + Embassy of Kuwait Bangkok + Tasdiq MOFA Kuwait City ก่อนใช้กับ Public Authority of Manpower (PAM), MOI, MOH, Family Court (Mahkamat Al-Usra) ภายใต้ Civil Code 67/1980 + Personal Status Law 51/1984",
  "author": "NYC Document Team",
  "publishedAt": "2026-07-15",
  "updatedAt": "2026-07-15"
 },
 {
  "slug": "oman-document-legalization-corridor-th-2026",
  "title": "เอกสารไทย → โอมาน 2026: MFA + Embassy + MOFA Muscat",
  "category": "Legalization",
  "tags": [
   "oman",
   "embassy",
   "tasdiq",
   "muscat",
   "non-hague",
   "gcc"
  ],
  "readMinutes": 8,
  "excerpt": "سلطنة عُمان ยังไม่เข้า Hague Apostille — เอกสารไทยต้อง chain MFA + Embassy of Oman Bangkok + Tasdiq MOFA Muscat (Al Khuwair) ก่อนใช้กับ MoL Invest Easy, Royal Oman Police (ROP), MOH Sahaty, Sharia Court, MOHERI ภายใต้ Basic Law 101/1996 + Personal Status Law 32/1997",
  "author": "NYC Document Team",
  "publishedAt": "2026-07-15",
  "updatedAt": "2026-07-15"
 },
 {
  "slug": "bahrain-document-legalization-corridor-th-2026",
  "title": "เอกสารไทย → บาห์เรน 2026: Apostille + Arabic Translation Manama",
  "category": "Legalization",
  "tags": [
   "bahrain",
   "apostille",
   "hague",
   "manama",
   "gcc"
  ],
  "readMinutes": 8,
  "excerpt": "مملكة البحرين เข้า Hague Apostille Convention 1961 มีผล 31 ธ.ค. 2013 — เป็นประเทศ GCC แห่งเดียวที่เข้า เอกสารไทย Apostille MFA Thailand ใช้ตรงกับ LMRA, MOI eKey, NHRA, Sharia Court, SLRB ไม่ต้องผ่าน Embassy of Bahrain Bangkok อีก — ลดเวลา 60% + ค่าใช้จ่าย 50% เทียบกับ Saudi/UAE/Qatar/Kuwait/Oman",
  "author": "NYC Document Team",
  "publishedAt": "2026-07-15",
  "updatedAt": "2026-07-15"
 },
 {
  "slug": "syria-document-legalization-corridor-th-2026",
  "title": "Syria Document Legalisation Corridor 2026 — chain, sanctions, และความเสี่ยงสงคราม",
  "category": "Legalization",
  "tags": [
   "syria",
   "tasdiq",
   "sanctions",
   "ofac",
   "embassy-legalization"
  ],
  "readMinutes": 16,
  "excerpt": "Syria เป็นเขตเสี่ยงสูง (FCDO Red + OFAC CAESAR Act 2019) แต่ Personal Status documents ที่ไม่เกี่ยวพันการเงิน/เทคโนโลยีต้องห้าม ยังทำได้ผ่าน chain 4 ขั้น Beirut/Amman",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-29",
  "updatedAt": "2026-06-29"
 },
 {
  "slug": "yemen-document-legalization-corridor-th-2026",
  "title": "Yemen Document Legalisation Corridor 2026 — chain, Houthi vs ROYG, และความเสี่ยง",
  "category": "Legalization",
  "tags": [
   "yemen",
   "tasdiq",
   "sanctions",
   "houthi",
   "embassy-legalization"
  ],
  "readMinutes": 14,
  "excerpt": "Yemen แบ่ง 2 รัฐบาล: ROYG (Aden, รับรองโดย UN) vs Houthi (Sana'a, ไม่ได้รับรอง) — chain ขึ้นกับปลายทาง + คนของรัฐบาลไหน",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-29",
  "updatedAt": "2026-06-29"
 },
 {
  "slug": "libya-document-legalization-corridor-th-2026",
  "title": "Libya Document Legalisation Corridor 2026 — GNU Tripoli vs HoR Tobruk",
  "category": "Legalization",
  "tags": [
   "libya",
   "tasdiq",
   "sanctions",
   "embassy-legalization"
  ],
  "readMinutes": 14,
  "excerpt": "Libya แบ่ง 2 รัฐบาล: GNU Tripoli (UN รับรอง) vs HoR Tobruk + LNA Haftar — chain ขึ้นกับปลายทาง",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-29",
  "updatedAt": "2026-06-29"
 },
 {
  "slug": "palestine-document-legalization-corridor-th-2026",
  "title": "Palestine Document Legalisation Corridor 2026 — PA Ramallah vs Hamas Gaza",
  "category": "Legalization",
  "tags": [
   "palestine",
   "tasdiq",
   "embassy-legalization",
   "west-bank",
   "gaza"
  ],
  "readMinutes": 14,
  "excerpt": "Palestine แบ่ง 2 areas: PA West Bank (Ramallah-based) vs Gaza (Hamas-controlled ตั้งแต่ 2007) — chain ขึ้นกับ destination + Israel COGAT coordination",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-29",
  "updatedAt": "2026-06-29"
 }
] as BlogCardMeta[];

export const BLOG_INDEX_EN: BlogCardMeta[] = [
 {
  "slug": "apostille-thailand-2024-guide",
  "title": "How Thailand's 2024 Apostille Accession Changes Your Paperwork",
  "category": "Apostille",
  "tags": [
   "apostille",
   "MFA",
   "legalization",
   "thailand"
  ],
  "readMinutes": 8,
  "excerpt": "After 60+ years of relying on dual legalization, Thailand's Ministry of Foreign Affairs now issues Apostilles accepted in 125+ Hague countries. This guide explains exactly what changed for expats.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-03-10",
  "updatedAt": "2026-05-20"
 },
 {
  "slug": "marriage-thailand-foreigners",
  "title": "Marrying in Thailand as a Foreigner — Document Checklist by Embassy",
  "category": "Marriage",
  "tags": [
   "marriage",
   "thai marriage",
   "embassy affirmation"
  ],
  "readMinutes": 10,
  "excerpt": "Marrying in Thailand requires an embassy affirmation, a sworn Thai translation, and an MFA stamp before the amphur will register your marriage. Here's the full embassy-by-embassy breakdown.",
  "author": "Attorney Somchai L.",
  "publishedAt": "2026-02-22",
  "updatedAt": "2026-05-18"
 },
 {
  "slug": "non-b-vs-ltr-vs-dtv",
  "title": "Non-B vs LTR vs DTV: Which Thai Visa Fits Your 2026 Plans?",
  "category": "Visa",
  "tags": [
   "LTR",
   "DTV",
   "Non-B",
   "thai visa"
  ],
  "readMinutes": 12,
  "excerpt": "Three popular long-stay options for foreigners in Thailand. Each has different income thresholds, tax treatment, and family-inclusion rules. Here's a clear decision framework.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-01-30",
  "updatedAt": "2026-05-25"
 },
 {
  "slug": "notarised-poa-thailand",
  "title": "Notarised Power of Attorney in Thailand — When & How",
  "category": "Notary",
  "tags": [
   "POA",
   "power of attorney",
   "notary",
   "notarial-services-attorney"
  ],
  "readMinutes": 6,
  "excerpt": "A Power of Attorney lets someone act on your behalf for property, banking, court, or immigration matters. In Thailand it must be notarised by a Notarial Services Attorney, not a regular notary.",
  "author": "Attorney Pichaya R.",
  "publishedAt": "2026-02-05",
  "updatedAt": "2026-05-12"
 },
 {
  "slug": "translating-birth-certificate-th-en",
  "title": "Translating a Thai Birth Certificate for Foreign Embassies",
  "category": "Translation",
  "tags": [
   "birth certificate",
   "sworn translation",
   "MFA"
  ],
  "readMinutes": 5,
  "excerpt": "A Thai birth certificate (Sor Chor 19) needs three things before a foreign embassy will accept it: a sworn translation, MFA legalization or Apostille, and (for non-Hague countries) embassy stamp.",
  "author": "NYC Translation Team",
  "publishedAt": "2026-01-18",
  "updatedAt": "2026-05-08"
 },
 {
  "slug": "mfa-legalization-walkthrough",
  "title": "MFA Legalization (Chaeng Wattana) — A Visual Walkthrough",
  "category": "Legalization",
  "tags": [
   "MFA",
   "Chaeng Wattana",
   "legalization"
  ],
  "readMinutes": 7,
  "excerpt": "The MFA's Department of Consular Affairs in Chaeng Wattana legalises ~3,000 documents per day. Here's exactly what happens between walking in and walking out with stamped papers.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-02-14",
  "updatedAt": "2026-05-22"
 },
 {
  "slug": "criminal-record-check-thailand-expats",
  "title": "Thai Police Clearance for Expats — How to Get It Abroad",
  "category": "Translation",
  "tags": [
   "police clearance",
   "criminal record",
   "PCC",
   "fingerprint"
  ],
  "readMinutes": 8,
  "excerpt": "A Thai Police Clearance Certificate (PCC) is required for many overseas visa applications including UK Skilled Worker, Australian PR, Canadian PR, and German residence permits.",
  "author": "Attorney Somchai L.",
  "publishedAt": "2026-03-02",
  "updatedAt": "2026-05-19"
 },
 {
  "slug": "naati-translation-australia-visa",
  "title": "NAATI Certified Translation — What Australian Visas Require",
  "category": "Translation",
  "tags": [
   "NAATI",
   "Australia visa",
   "certified translation"
  ],
  "readMinutes": 6,
  "excerpt": "The Department of Home Affairs requires every non-English document in your Australian visa application to be translated by a NAATI-credentialed translator. Here's how it works from Thailand.",
  "author": "NYC Translation Team",
  "publishedAt": "2026-03-22",
  "updatedAt": "2026-05-26"
 },
 {
  "slug": "work-permit-thailand-2026",
  "title": "Thailand Work Permit 2026 — Documents, Timeline, and Common Mistakes",
  "category": "Work Permit",
  "tags": [
   "work permit",
   "Non-B",
   "Thai labour"
  ],
  "readMinutes": 9,
  "excerpt": "Working legally in Thailand requires a Work Permit (WP3) issued by the Department of Employment. Process changed in 2024 with the e-Workpermit platform — here's the current state.",
  "author": "Attorney Pichaya R.",
  "publishedAt": "2026-03-15",
  "updatedAt": "2026-05-24"
 },
 {
  "slug": "embassy-legalization-non-hague-countries",
  "title": "Embassy Legalization for Non-Hague Countries — UAE, China, Vietnam",
  "category": "Legalization",
  "tags": [
   "embassy legalization",
   "UAE",
   "China",
   "Vietnam"
  ],
  "readMinutes": 8,
  "excerpt": "If your destination country isn't a Hague Apostille member, you need the old two-step legalization: MFA Bangkok + destination embassy in Bangkok. Here's the timeline and cost per country.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-04-08",
  "updatedAt": "2026-05-28"
 },
 {
  "slug": "hague-apostille-thailand-2-year-update-2026",
  "title": "Two Years In: How Thailand's Hague Apostille Is Working in 2026",
  "category": "Apostille",
  "tags": [
   "Apostille",
   "Hague Convention",
   "MFA Legalization",
   "Thailand"
  ],
  "readMinutes": 10,
  "excerpt": "Two years after Thailand's accession to the Hague Apostille Convention took effect on 15 December 2024, here is a practitioner's status report: which destinations now accept Apostille, which still require the old dual legalization chain, current MFA fees and turnaround times, and the most common mistakes foreigners make.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-24",
  "updatedAt": "2026-06-24"
 },
 {
  "slug": "same-sex-marriage-thailand-2026-foreigner-guide",
  "title": "Same-Sex Marriage in Thailand 2026 — A Complete Guide for Foreign Couples",
  "category": "Marriage",
  "tags": [
   "Same-Sex Marriage",
   "Marriage Equality",
   "Thailand",
   "LGBTQ+"
  ],
  "readMinutes": 12,
  "excerpt": "On 23 January 2025 the Marriage Equality Act (Act Amending the Civil and Commercial Code, No. 24) came into force, making Thailand the first country in Southeast Asia to legalize same-sex marriage. This guide walks foreign same-sex couples through the full document and registration workflow at any Thai district office (Amphoe), and explains how to make the marriage legally recognized in your home country.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-24",
  "updatedAt": "2026-06-24"
 },
 {
  "slug": "naati-translation-matrix-australian-agencies-2026",
  "title": "NAATI Translation Matrix 2026 — Which Document Goes to Which Australian Agency",
  "category": "Translation",
  "tags": [
   "NAATI",
   "Australia",
   "DHA",
   "AHPRA",
   "VETASSESS",
   "Engineers Australia"
  ],
  "readMinutes": 12,
  "excerpt": "Thai applicants for Australian visas, skills assessments, and professional registration deal with at least seven different agencies, each with its own document-format expectations. This matrix maps every commonly-needed Thai document to the agency that requires it, the NAATI translation format expected, and the 2026 fee/turnaround per pathway.",
  "author": "NYC NAATI Team",
  "publishedAt": "2026-06-24",
  "updatedAt": "2026-06-24"
 },
 {
  "slug": "ltr-wealthy-pensioner-visa-thailand-2026-guide",
  "title": "Thailand LTR Wealthy Pensioner Visa 2026 — Complete Guide for Retirees Aged 50+",
  "category": "Visa",
  "tags": [
   "LTR Visa",
   "Retirement Visa",
   "BOI",
   "Wealthy Pensioner",
   "Long-Term Resident"
  ],
  "readMinutes": 13,
  "excerpt": "Thailand's Long-Term Resident (LTR) Wealthy Pensioner category — launched September 2022 and refined through 2025-2026 — offers retirees aged 50+ a 10-year renewable visa, multi-entry stamps, a single 90-day reporting cycle, and a 17% income tax cap on Thai-sourced earnings. This guide breaks down the 2026 eligibility, the BOI application process, document checklist, and how the LTR-WP compares to the older O-A Retirement and the Thailand Privilege visas.",
  "author": "NYC Visa Team",
  "publishedAt": "2026-06-24",
  "updatedAt": "2026-06-24"
 },
 {
  "slug": "us-k1-fiance-visa-thailand-document-pack-2026",
  "title": "US K-1 Fiancé(e) Visa from Thailand 2026 — Complete Document Pack",
  "category": "Visa",
  "tags": [
   "K-1",
   "Fiance Visa",
   "US Embassy Bangkok",
   "Apostille",
   "USCIS"
  ],
  "readMinutes": 14,
  "excerpt": "Every Thai fiancé(e) of a US citizen must clear three agencies — USCIS, NVC, and US Embassy Bangkok — across roughly 10 months. This guide maps every document, apostille step, and translation requirement.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-23",
  "updatedAt": "2026-06-23"
 },
 {
  "slug": "thailand-tax-residency-foreign-income-2026-guide",
  "title": "Thailand Tax Residency and Foreign Income 2026 — Expat Survival Guide",
  "category": "Visa",
  "tags": [
   "Tax Residency",
   "Foreign Income",
   "Por 161",
   "Por 162",
   "LTR",
   "DTA"
  ],
  "readMinutes": 16,
  "excerpt": "Thailand's Revenue Department reversed 40 years of practice in late 2023. This guide explains exactly when foreign income becomes taxable, who is exempt, and how to file under the new Por 161/162 regime.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-24",
  "updatedAt": "2026-06-24"
 },
 {
  "slug": "apostille-uk-thailand-corridor-2026",
  "title": "UK ↔ Thailand Apostille Corridor 2026 — Spouse Visa, Skilled Worker & Ecctis Walkthrough",
  "category": "Apostille",
  "tags": [
   "uk",
   "apostille",
   "spouse visa",
   "skilled worker",
   "fcdo",
   "ecctis"
  ],
  "readMinutes": 11,
  "excerpt": "The complete 2026 playbook for UK ↔ Thailand document flow: when to apostille in Bangkok vs. Milton Keynes, how to clear the £29,000 spouse threshold, when Ecctis is mandatory, and the exact sequence from Thai documents to a UK Biometric Residence Permit.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-25",
  "updatedAt": "2026-06-25"
 },
 {
  "slug": "apostille-canada-thailand-corridor-2026",
  "title": "Canada ↔ Thailand Apostille Corridor 2026 — Express Entry, WES & Spousal Sponsorship",
  "category": "Apostille",
  "tags": [
   "canada",
   "apostille",
   "express entry",
   "spousal sponsorship",
   "wes",
   "ircc"
  ],
  "readMinutes": 11,
  "excerpt": "Canada's January 2024 Apostille accession transformed Thailand ↔ Canada paperwork. This guide covers the IRCC portal workflow for Express Entry, the WES ECA process, Spousal Sponsorship (Inland vs Outland), PNP options, and 2026 CRS cut-offs.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-25",
  "updatedAt": "2026-06-25"
 },
 {
  "slug": "apostille-australia-thailand-corridor-2026",
  "title": "Australia ↔ Thailand Apostille Corridor 2026 — Partner Visa, Skilled Migration & NAATI",
  "category": "Apostille",
  "tags": [
   "australia",
   "apostille",
   "partner visa",
   "skilled migration",
   "naati",
   "immi"
  ],
  "readMinutes": 12,
  "excerpt": "Australia is a Hague Apostille member since 1995 — but Thai documents still need a precise NAATI-Certified translation chain to land in ImmiAccount. This guide covers Partner Visas, Skilled Migration points, Skill Assessment authorities, and the end-to-end workflow.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-25",
  "updatedAt": "2026-06-25"
 },
 {
  "slug": "apostille-new-zealand-thailand-corridor-2026",
  "title": "New Zealand ↔ Thailand Apostille Corridor 2026 — Partner, Skilled Migrant & NZQA",
  "category": "Apostille",
  "tags": [
   "new zealand",
   "apostille",
   "smc",
   "partner visa",
   "nzqa",
   "aewv"
  ],
  "readMinutes": 11,
  "excerpt": "New Zealand's Skilled Migrant Category was overhauled in October 2023 to a simplified 6-point system. This guide maps the corridor — DIA Apostille, NZQA IQA for Thai qualifications, AEWV 3-Check system, and end-to-end Thailand to Wellington workflow.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-25",
  "updatedAt": "2026-06-25"
 },
 {
  "slug": "apostille-japan-thailand-corridor-2026",
  "title": "Japan ↔ Thailand Apostille Corridor 2026 — Spouse Visa, HSP & Engineer Routes",
  "category": "Apostille",
  "tags": [
   "japan",
   "apostille",
   "spouse visa",
   "hsp",
   "engineer visa"
  ],
  "readMinutes": 12,
  "excerpt": "Both Japan (Hague member since 1970) and Thailand (since July 2024) issue Apostilles. This guide details the MOFA Japan whitelist, Ward Office Kekkon Todoke registration, and 2026 HSP/Engineer thresholds for Thai applicants.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-25",
  "updatedAt": "2026-06-25"
 },
 {
  "slug": "apostille-korea-thailand-corridor-2026",
  "title": "South Korea ↔ Thailand Apostille Corridor 2026 — F-6, E-7 & D-2 Visas",
  "category": "Apostille",
  "tags": [
   "korea",
   "apostille",
   "f-6 visa",
   "e-7 visa",
   "d-2 student"
  ],
  "readMinutes": 12,
  "excerpt": "South Korea (Hague member since 2007) and Thailand (since July 2024) operate a fully bidirectional Apostille corridor. This guide covers F-6, E-7, D-2 visas plus the mandatory KCUE diploma verification and HiKorea online lodgement.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-25",
  "updatedAt": "2026-06-25"
 },
 {
  "slug": "apostille-germany-thailand-corridor-2026",
  "title": "Germany ↔ Thailand Apostille Corridor 2026: Standesamt, Anabin, Blue Card & Skilled Migration",
  "category": "Apostille",
  "tags": [
   "apostille",
   "germany",
   "blue-card",
   "standesamt",
   "anabin"
  ],
  "readMinutes": 16,
  "excerpt": "Germany is Thailand's largest EU trading partner and a top destination for Thai skilled migrants under the 2023 Skilled Immigration Act. With both countries on the Hague Apostille Convention since 2024, the corridor now runs on a clean three-step chain — but Anabin database checks, beeidigte Übersetzer translation rules, and Standesamt local-office variances still trip up applicants.",
  "author": "Apostille Corridor Desk",
  "publishedAt": "2026-06-25",
  "updatedAt": "2026-06-25"
 },
 {
  "slug": "apostille-france-thailand-corridor-2026",
  "title": "France ↔ Thailand Apostille Corridor 2026: Mairie, PACS, Traducteur Assermenté & VLS-TS",
  "category": "Apostille",
  "tags": [
   "apostille",
   "france",
   "vls-ts",
   "mairie",
   "pacs",
   "talent-passport"
  ],
  "readMinutes": 16,
  "excerpt": "France is Thailand's 3rd-largest EU partner with ~25,000 Thai nationals residing under various Cartes de Séjour. The 2024 Hague entry simplified document chains but introduced new constraints — traducteur assermenté at Cour d'Appel level, OFII medical visit, and dual-route choice between mariage civil and PACS each carry distinct paperwork and timeline impacts.",
  "author": "Apostille Corridor Desk",
  "publishedAt": "2026-06-25",
  "updatedAt": "2026-06-25"
 },
 {
  "slug": "schengen-visa-from-thailand-2026-complete-guide",
  "title": "Schengen Visa from Thailand 2026: Complete Application Guide for Thai & Foreign Residents",
  "category": "Visa",
  "tags": [
   "schengen",
   "visa",
   "europe",
   "etias",
   "ees"
  ],
  "readMinutes": 16,
  "excerpt": "The Schengen Area covers 29 European countries (27 EU + Switzerland + Norway + Iceland + Liechtenstein, minus Ireland and Cyprus) with a single uniform short-stay visa. With EES biometric entry/exit live since 10 October 2025 and ETIAS launching Q4 2026, Thai-issued Schengen visas now sit inside a fully digital border ecosystem — but the application paperwork is unchanged.",
  "author": "Visa Desk",
  "publishedAt": "2026-06-25",
  "updatedAt": "2026-06-25"
 },
 {
  "slug": "saudi-arabia-work-visa-document-legalization-thailand-2026",
  "title": "Saudi Arabia Work Visa from Thailand 2026: Document Legalization, Saudization & Vision 2030",
  "category": "Visa",
  "tags": [
   "saudi-arabia",
   "work-visa",
   "legalization",
   "iqama",
   "vision-2030"
  ],
  "readMinutes": 16,
  "excerpt": "Saudi Arabia is Thailand's largest Middle East trade partner since the 2022 Saudi-Thai relations restoration. With Vision 2030 mega-projects (NEOM, The Red Sea, Qiddiya, Diriyah, AlUla) creating ~120,000 expat positions for Thai workers in construction, hospitality, healthcare, and engineering through 2030, the Saudi work visa pipeline runs through a strict 5-step legalization chain that NYC streamlines.",
  "author": "Embassy Legalization Desk",
  "publishedAt": "2026-06-25",
  "updatedAt": "2026-06-25"
 },
 {
  "slug": "dtv-destination-thailand-visa-complete-guide-2026",
  "title": "DTV Destination Thailand Visa 2026: Digital Nomad, Soft Power, Remote Worker Complete Guide",
  "category": "Visa",
  "tags": [
   "dtv",
   "digital-nomad",
   "remote-work",
   "thailand-visa",
   "soft-power"
  ],
  "readMinutes": 16,
  "excerpt": "Launched 15 July 2024, the Destination Thailand Visa (DTV) is Thailand's most flexible long-stay visa — 5 years multi-entry, 180-day permitted stays per entry (extendable by 180 days inside Thailand), eligible to remote workers worldwide and to anyone enrolled in Thai soft-power activities (Muay Thai, Thai cooking, traditional medicine, sports training). At THB 10,000 with online application via Thai e-Visa portal, the DTV has issued ~85,000 visas in its first 18 months.",
  "author": "Thailand Visa Desk",
  "publishedAt": "2026-06-25",
  "updatedAt": "2026-06-25"
 },
 {
  "slug": "uae-thailand-document-legalization-corridor-2026",
  "title": "UAE ↔ Thailand Document Legalization Corridor 2026: Golden Visa, Free-Zone Employment & Family Sponsorship",
  "category": "Legalization",
  "tags": [
   "uae",
   "dubai",
   "abu-dhabi",
   "golden-visa",
   "mofaic",
   "free-zone"
  ],
  "readMinutes": 18,
  "excerpt": "UAE never joined the Hague Apostille Convention. Every Thai-issued document destined for Dubai, Abu Dhabi, Sharjah, or free zones (DMCC, DIFC, ADGM, JAFZA) requires the full 4-step legalization chain: MFA Bangkok → UAE Embassy Bangkok → MOFAIC Dubai/Abu Dhabi → end-user authority (MOHRE, GDRFA, MOE, court). Conversely, UAE-issued documents for Thailand need MOFAIC + Thai Embassy Abu Dhabi stamping. This guide covers Golden Visa investment thresholds (AED 2M property, AED 2M business, scientist/specialist categories), Equivalency Certificates for engineering/medical professionals, family sponsorship salary requirements (AED 4,000+ housing), and the 2025 Federal Decree-Law on Personal Status that simplified expat family law.",
  "author": "NYC Editorial Team",
  "publishedAt": "2026-06-25",
  "updatedAt": "2026-06-25"
 },
 {
  "slug": "singapore-thailand-document-corridor-2026",
  "title": "Singapore ↔ Thailand Document Corridor 2026: Apostille, EP/PEP, Tech.Pass & Family Schemes",
  "category": "Apostille",
  "tags": [
   "singapore",
   "apostille",
   "employment-pass",
   "tech-pass",
   "one-pass"
  ],
  "readMinutes": 17,
  "excerpt": "Singapore acceded to the Hague Apostille Convention on 16 September 2021 — both Thailand (since 24 December 2024) and Singapore are now Convention members, eliminating the previous 4-step Embassy chain. Singapore documents for Thailand: SAL (Singapore Academy of Law) Apostille → Thai translation → MFA Bangkok translation legalization. Thailand documents for Singapore: MFA Bangkok Apostille → direct submission to MOM, ICA, MOE, MAS, ACRA, Family Justice Courts. This bilateral simplification cuts 10-14 days off every corridor transaction. Below: Employment Pass tiered salaries (S$5,000-10,500 by sector + age), Personalised EP (PEP), Tech.Pass for AI/blockchain/Web3, ONE Pass for top talent, Dependant Pass, and the 2025 LTVP+ extension to same-sex partners.",
  "author": "NYC Editorial Team",
  "publishedAt": "2026-06-25",
  "updatedAt": "2026-06-25"
 },
 {
  "slug": "qatar-work-visa-thai-2026",
  "title": "Qatar Work Visa & Document Legalization for Thai Professionals 2026",
  "category": "Legalization",
  "tags": [
   "qatar",
   "embassy",
   "legalization",
   "work-visa",
   "gcc"
  ],
  "readMinutes": 11,
  "excerpt": "Qatar's labor reform post-2022 World Cup opened skilled-worker channels for Thai engineers, hospitality professionals, healthcare workers, and educators. Because Qatar is not yet an Apostille member, all Thai documents follow the classic 3-step legalization chain — MOFA Thailand + Qatar Embassy Bangkok + MOFA Qatar Doha.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-25",
  "updatedAt": "2026-06-25"
 },
 {
  "slug": "taiwan-work-visa-thai-2026",
  "title": "Taiwan Work Visa & Document Authentication for Thai Professionals 2026",
  "category": "Legalization",
  "tags": [
   "taiwan",
   "teco",
   "gold-card",
   "work-visa",
   "east-asia"
  ],
  "readMinutes": 11,
  "excerpt": "Taiwan's Employment Gold Card has attracted 10,000+ international professionals since 2018 — Thais are eligible under 8 categories from tech to finance. Because Taiwan is not a Hague Apostille member (UN status), documents require TECO Bangkok authentication instead.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-25",
  "updatedAt": "2026-06-25"
 },
 {
  "slug": "india-document-legalization-thai-2026",
  "title": "India Apostille for Thai Documents 2026 — Post-Hague Era Guide",
  "category": "Apostille",
  "tags": [
   "india",
   "apostille",
   "oci",
   "work-visa",
   "south-asia"
  ],
  "readMinutes": 11,
  "excerpt": "India acceded to the Hague Apostille Convention in 2005 — so since Thailand's December 2024 accession, the Thailand-India corridor enjoys streamlined single-Apostille document flow. Combined with India's rising tech/manufacturing demand and OCI (Overseas Citizen of India) reforms, the corridor is increasingly active for Thai professionals.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-25",
  "updatedAt": "2026-06-25"
 },
 {
  "slug": "malaysia-document-legalization-thai-2026",
  "title": "Malaysia Document Legalization for Thai Citizens 2026: Apostille, Work Visa & MM2H",
  "category": "Legalization",
  "tags": [
   "malaysia",
   "apostille",
   "mm2h",
   "employment-pass",
   "asean"
  ],
  "readMinutes": 11,
  "excerpt": "Malaysia acceded to the Hague Apostille Convention with entry-into-force 16 December 2024. Thai documents now flow directly to KL with a single MFA stamp — no more dual legalization.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-27",
  "updatedAt": "2026-06-27"
 },
 {
  "slug": "vietnam-document-legalization-thai-2026",
  "title": "Vietnam Document Legalization for Thai Citizens 2026: Embassy Route, Work Permit & TRC",
  "category": "Legalization",
  "tags": [
   "vietnam",
   "embassy-legalization",
   "work-permit",
   "trc",
   "asean"
  ],
  "readMinutes": 11,
  "excerpt": "Unlike Malaysia and Singapore, Vietnam has not acceded to the Hague Apostille Convention. Thai documents still require dual legalization via MFA Bangkok + Vietnamese Embassy. Here is the full 2026 corridor playbook.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-27",
  "updatedAt": "2026-06-27"
 },
 {
  "slug": "naati-certified-translation-thailand-2026-australia-visa-guide",
  "title": "NAATI Certified Translation in Thailand 2026 — Complete Guide for Australian Visas",
  "category": "Translation",
  "tags": [
   "NAATI",
   "australia",
   "PR",
   "skilled-migration",
   "CCL"
  ],
  "readMinutes": 14,
  "excerpt": "Everything Thai-Australian migrants need to know about NAATI Certified Translation — from Partner Visa 820/801 through Skilled 189/190 to CCL Test for +5 PR points.",
  "author": "NYC Translation Bureau",
  "publishedAt": "2026-06-20",
  "updatedAt": "2026-06-27"
 },
 {
  "slug": "naati-ccl-test-thailand-2026-complete-prep-guide",
  "title": "NAATI CCL Test in Thailand 2026 — Complete Prep Guide for +5 PR Points (Thai-English)",
  "category": "Translation",
  "tags": [
   "NAATI",
   "CCL",
   "skilled-migration",
   "PR",
   "189",
   "190",
   "491"
  ],
  "readMinutes": 16,
  "excerpt": "Step-by-step CCL Test preparation guide for Thai-English candidates — what the exam tests, how to pass on the first attempt, and why +5 points is the highest-ROI move in Skilled Migration.",
  "author": "NYC Translation Bureau",
  "publishedAt": "2026-06-25",
  "updatedAt": "2026-06-27"
 },
 {
  "slug": "thai-police-clearance-certificate-2026-complete-global-migration-guide",
  "title": "Thai Police Clearance Certificate 2026 — Complete Global Migration Guide",
  "category": "Legalization",
  "tags": [
   "police clearance",
   "migration",
   "apostille",
   "embassy",
   "thai immigration"
  ],
  "readMinutes": 14,
  "excerpt": "A practical 2026 guide to the Thai Police Clearance Certificate for migration — filing, fingerprints, MFA Apostille vs. legalisation, validity per country, and how to avoid the three errors that cause 90% of refusals.",
  "author": "NYC Legal Editorial",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "mfa-legalisation-vs-apostille-thailand-2026-complete-comparison",
  "title": "MFA Legalisation vs Apostille Thailand 2026 — Complete Comparison Guide",
  "category": "Apostille",
  "tags": [
   "apostille",
   "legalisation",
   "mfa",
   "hague convention",
   "consular"
  ],
  "readMinutes": 16,
  "excerpt": "Thailand acceded on 30 June 2026 (in force for Thailand 28 February 2027). This guide answers the question every applicant now asks: Apostille or Legalisation — and proves it with a country-by-country decision tree.",
  "author": "NYC Legal Editorial",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "gcc-embassy-legalisation-thailand-2026-complete-guide",
  "title": "GCC Embassy Legalisation in Thailand 2026 — UAE, Saudi Arabia, Kuwait & Qatar Complete Guide",
  "category": "Legalization",
  "tags": [
   "embassy",
   "UAE",
   "saudi-arabia",
   "kuwait",
   "qatar",
   "GCC",
   "legalization"
  ],
  "readMinutes": 12,
  "excerpt": "Even after Thailand's 2024 Hague accession, every Gulf Cooperation Council (GCC) embassy in Bangkok still requires the traditional MFA + Consular Legalisation chain. This guide maps every fee, queue, and document requirement so you can plan a GCC employment, family-visa, or commercial filing without surprises.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "japan-document-legalization-corridor",
  "title": "Japan Document Legalisation from Thailand 2026 — Apostille, Translation & Embassy Workflow",
  "category": "Legalization",
  "tags": [
   "japan",
   "apostille",
   "embassy",
   "legalization",
   "translation-japanese"
  ],
  "readMinutes": 11,
  "excerpt": "Japan acceded to the Hague Apostille Convention in 1970 — so Thai-issued documents bearing an MFA Apostille are accepted in Japan without embassy legalisation. This guide maps the entire 2026 corridor from a Thai-language source document to acceptance at the Tokyo Legal Affairs Bureau, Immigration Services Agency (ISA), and ward office (kuyakusho).",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "south-korea-document-legalization-corridor",
  "title": "South Korea Document Legalisation from Thailand 2026 — Apostille, K-ETA, F-Visa Complete Guide",
  "category": "Legalization",
  "tags": [
   "south-korea",
   "apostille",
   "embassy",
   "legalization",
   "F-visa",
   "translation-korean"
  ],
  "readMinutes": 11,
  "excerpt": "South Korea joined the Hague Apostille Convention on 14 July 2007. Combined with Thailand's December 2023 accession, the corridor is now Apostille-only — no Korean Embassy legalisation required for civil, academic, or commercial documents.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "india-document-legalization-corridor",
  "title": "Thai Documents for India 2026 — Post-Hague Apostille Corridor",
  "category": "Legalization",
  "tags": [
   "india",
   "apostille",
   "OCI",
   "MEA",
   "legalization"
  ],
  "readMinutes": 9,
  "excerpt": "India has been a Hague Apostille party since 2005; Thailand acceded on 30 June 2026 (in force for Thailand 28 February 2027). The Thai → India corridor now skips the Embassy of India in Bangkok entirely — a single MFA Apostille is sufficient.",
  "author": "NYC Legal Editorial Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "taiwan-document-legalization-corridor",
  "title": "Thai Documents for Taiwan 2026 — TECO Bangkok Corridor",
  "category": "Legalization",
  "tags": [
   "taiwan",
   "TECO",
   "legalization",
   "gold-card",
   "marriage"
  ],
  "readMinutes": 9,
  "excerpt": "Taiwan is not a Hague Apostille member and, due to its UN status, will not join in the foreseeable future. The Thai → Taiwan corridor still requires the full three-step chain: MFA Thailand → TECO Bangkok → MOFA Taipei.",
  "author": "NYC Legal Editorial Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "germany-document-legalization-corridor",
  "title": "Germany Document Legalisation from Thailand — 2026 Complete Guide",
  "category": "Legalization",
  "tags": [
   "germany",
   "apostille",
   "standesamt",
   "zab",
   "sworn-translation"
  ],
  "readMinutes": 11,
  "excerpt": "Since Thailand's Hague accession (28 February 2027), the Germany corridor is now Apostille + vereidigter Übersetzer — no German Embassy Bangkok attestation. NYC closes a typical Familienzusammenführung pack in 9–12 business days.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "china-document-legalization-corridor-2026",
  "title": "China Document Legalisation from Thailand — Post-Hague 2026 Complete Guide",
  "category": "Legalization",
  "tags": [
   "china",
   "apostille",
   "z-visa",
   "residence-permit",
   "notary-office"
  ],
  "readMinutes": 11,
  "excerpt": "China acceded to the Hague Apostille Convention on 7 November 2023. Thailand's accession entered into force 28 February 2027. NYC closes a residence-permit pack in 6–9 business days — no more Chinese Embassy queue.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "france-document-legalization-corridor",
  "title": "France Document Legalisation Corridor 2026: Thai MFA Apostille, Traducteur Assermenté, OFII, Visa Long Séjour",
  "category": "Legalization",
  "tags": [
   "france",
   "apostille",
   "ofii",
   "mairie",
   "traducteur-assermente"
  ],
  "readMinutes": 11,
  "excerpt": "France is a Hague Apostille party since 1965. Thailand acceded on 30 June 2026 (in force for Thailand 28 February 2027). The French Embassy in Bangkok no longer legalises Thai documents — but every translation must be re-done in France by a court-sworn translator.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "italy-document-legalization-corridor",
  "title": "Italy Document Legalisation Corridor 2026: Apostille, Dichiarazione di Valore, CIMEA, Comune Marriage",
  "category": "Legalization",
  "tags": [
   "italy",
   "apostille",
   "dichiarazione-di-valore",
   "cimea",
   "comune"
  ],
  "readMinutes": 11,
  "excerpt": "Apostille will replace Italian Embassy legalisation from 28 February 2027 — but Dichiarazione di Valore is still required for university admissions, and CIMEA provides a faster online alternative for €170.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "australia-document-legalization-corridor",
  "title": "Australia Document Legalisation Corridor 2026: Thai MFA Apostille, NAATI Certified Translation, AHPRA, VETASSESS",
  "category": "Legalization",
  "tags": [
   "australia",
   "apostille",
   "naati",
   "ahpra",
   "vetassess"
  ],
  "readMinutes": 11,
  "excerpt": "Australia accepts Thai MFA Apostille directly — but every Thai document must be translated by a NAATI Certified Translator with current CPN. NYC issues NAATI + Apostille in a single workflow.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "spain-document-legalization-corridor",
  "title": "Spain Document Legalisation Corridor 2026: Thai MFA Apostille, Traductor Jurado, NIE & Registro Civil",
  "category": "Legalization",
  "tags": [
   "spain",
   "apostille",
   "traductor-jurado",
   "nie",
   "homologacion"
  ],
  "readMinutes": 11,
  "excerpt": "Spain is Hague Apostille since 1978; with Thailand acceding 28 February 2027 the Spanish Embassy Bangkok will no longer legalise Thai documents. Every translation must be done by a Traductor-Intérprete Jurado appointed by the MAEC.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "uk-document-legalization-corridor",
  "title": "UK Document Legalisation Corridor 2026: Thai MFA Apostille, Home Office, NMC, GMC, ECCTR Marriage",
  "category": "Legalization",
  "tags": [
   "uk",
   "apostille",
   "home-office",
   "nmc",
   "gmc",
   "marriage"
  ],
  "readMinutes": 11,
  "excerpt": "The United Kingdom accepts Thai MFA Apostille directly for every Home Office, NMC, GMC, NARIC ENIC, and General Register Office filing. The UK Embassy Bangkok no longer legalises Thai documents.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "uae-document-legalization-corridor",
  "title": "UAE Document Legalisation Corridor 2026: Thai MFA + UAE Embassy Bangkok + MOFAIC Abu Dhabi Triple Chain",
  "category": "Legalization",
  "tags": [
   "uae",
   "embassy-legalization",
   "mofaic",
   "arabic-translation",
   "mohre"
  ],
  "readMinutes": 12,
  "excerpt": "The UAE is not a Hague Apostille party — Thai documents still require the full triple chain: MFA Bangkok → UAE Embassy Bangkok → MOFAIC Abu Dhabi, followed by Arabic translation by a Ministry of Justice–licensed translator inside the UAE.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "canada-document-legalization-corridor",
  "title": "Canada Document Legalisation Corridor 2026: Thai MFA Apostille, IRCC, WES, NNAS, MCC",
  "category": "Legalization",
  "tags": [
   "canada",
   "apostille",
   "ircc",
   "wes",
   "nnas",
   "quebec"
  ],
  "readMinutes": 11,
  "excerpt": "Canada became a Hague Apostille member on 11 January 2024, eighteen months before Thailand's accession. A Thai MFA Apostille is now accepted directly by IRCC, WES, NNAS, MCC, ICAS, and every provincial vital-statistics office — the Canadian Embassy Bangkok no longer legalises Thai documents.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "switzerland-document-legalization-corridor",
  "title": "Switzerland Document Legalisation Corridor 2026: Thai MFA Apostille, SEM, Zivilstandsamt, Swissmedic, FMH, Cantonal Sworn Translation",
  "category": "Legalization",
  "tags": [
   "switzerland",
   "apostille",
   "sem",
   "zivilstandsamt",
   "fmh",
   "swissmedic"
  ],
  "readMinutes": 11,
  "excerpt": "Switzerland has been a Hague Apostille member since 1973 — the earliest among Continental European destinations. A Thai MFA Apostille is accepted directly by SEM, every cantonal migration office, Zivilstandsamt for marriage transcription, FMH for medical registration, and Swissmedic for pharmaceutical-professional licensing.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "netherlands-document-legalization-corridor",
  "title": "Netherlands Document Legalisation Corridor 2026: Thai MFA Apostille, IND, Gemeente, BIG, Nuffic, beëdigd vertaler",
  "category": "Legalization",
  "tags": [
   "netherlands",
   "apostille",
   "ind",
   "gemeente",
   "big-register",
   "nuffic"
  ],
  "readMinutes": 10,
  "excerpt": "The Netherlands has been a Hague Apostille member since 1965. Thai MFA Apostille is accepted directly by IND, every Gemeente for BRP registration, BIG-register for healthcare, Nuffic for credential evaluation, and the Rechtbank for sworn-translation supervision. The Royal Netherlands Embassy in Bangkok will stop legalising Thai documents on 28 February 2027.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "sweden-document-legalization-corridor",
  "title": "Sweden Document Legalisation Corridor 2026: Thai MFA Apostille, Migrationsverket, Skatteverket, UHR, Socialstyrelsen, Kammarkollegiet sworn translation",
  "category": "Legalization",
  "tags": [
   "sweden",
   "apostille",
   "migrationsverket",
   "skatteverket",
   "uhr",
   "socialstyrelsen"
  ],
  "readMinutes": 11,
  "excerpt": "Sweden has been a Hague Apostille member since 1999. A Thai MFA Apostille is now accepted directly by Migrationsverket, Skatteverket for folkbokföring registration, UHR for academic evaluation, Socialstyrelsen for healthcare licensing, and every tingsrätt. The Swedish Embassy in Bangkok will stop legalising Thai documents on 28 February 2027.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "norway-document-legalization-corridor",
  "title": "Norway Document Legalisation Corridor 2026: Thai MFA Apostille, UDI, Skatteetaten, NOKUT, Helsedirektoratet, statsautorisert translatør",
  "category": "Legalization",
  "tags": [
   "norway",
   "apostille",
   "udi",
   "skatteetaten",
   "nokut",
   "helsedirektoratet"
  ],
  "readMinutes": 11,
  "excerpt": "Norway has been a Hague Apostille member since 1983. A Thai MFA Apostille is accepted directly by UDI, Skatteetaten for folkeregister registration, NOKUT for academic recognition, Helsedirektoratet for healthcare licensing, and every tingrett. The Royal Norwegian Embassy in Bangkok will stop legalising Thai documents on 28 February 2027.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "denmark-document-legalization-corridor",
  "title": "Denmark Document Legalisation Corridor 2026: Thai MFA Apostille, SIRI, Familieretshuset, Patientsikkerhed, UFM, professional translation",
  "category": "Legalization",
  "tags": [
   "denmark",
   "apostille",
   "siri",
   "familieretshuset",
   "ufm",
   "patientsikkerhed"
  ],
  "readMinutes": 10,
  "excerpt": "Denmark has been a Hague Apostille member since 2006 and Thailand acceded on 30 June 2026 (in force for Thailand 28 February 2027). A Thai MFA Apostille is accepted directly by SIRI, Familieretshuset, Styrelsen for Patientsikkerhed, the Danish Agency for Higher Education and Science (UFM), and every byret. Uniquely among Nordic destinations, Denmark abolished the sworn-translator monopoly in 2016 — a professional translator's signed declaration suffices.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "belgium-document-legalization-corridor",
  "title": "Belgium Document Legalisation Corridor 2026: Thai MFA Apostille, Office des Étrangers/DVZ, commune/gemeente, INAMI/RIZIV, NARIC, traducteur juré/beëdigd vertaler",
  "category": "Legalization",
  "tags": [
   "belgium",
   "apostille",
   "office-des-etrangers",
   "inami",
   "naric",
   "traducteur-jure"
  ],
  "readMinutes": 11,
  "excerpt": "Belgium has been a Hague Apostille member since 1976. A Thai MFA Apostille is accepted directly by Office des Étrangers/Dienst Vreemdelingenzaken, every commune/gemeente for civil-register transcription, INAMI/RIZIV for healthcare licensing, NARIC-Vlaanderen and ENIC-Naric Wallonia for academic recognition, and every tribunal de première instance. The Belgian Embassy in Bangkok will stop legalising Thai documents on 28 February 2027.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "naati-uk-us-canada-acceptance-2026",
  "title": "Is NAATI Accepted in the UK, US, and Canada? 2026 Guide (ATA, CTTIC, ITI/CIOL)",
  "category": "Translation",
  "tags": [
   "naati",
   "ata",
   "cttic",
   "iti",
   "uscis",
   "ircc",
   "ukvi"
  ],
  "readMinutes": 10,
  "excerpt": "NAATI accreditation is the gold standard inside Australia and New Zealand. For USCIS, IRCC, and UKVI, decision-makers prefer ATA, CTTIC, or ITI/CIOL credentials — or an MFA Apostille paired with a destination-country sworn translation.",
  "author": "NYC Translation Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "vietnam-document-legalization-corridor-en-2026",
  "title": "Thailand → Vietnam Document Legalisation Corridor 2026 (Non-Hague Chain)",
  "category": "Legalization",
  "tags": [
   "vietnam",
   "embassy",
   "legalization",
   "trc",
   "work-permit"
  ],
  "readMinutes": 9,
  "excerpt": "Vietnam is not a Hague Apostille party — Thai documents still require the full chain: MFA + Vietnamese Embassy Bangkok + Cục Lãnh sự before use at Sở Tư pháp/DOLISA.",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "indonesia-document-legalization-corridor-en-2026",
  "title": "Thailand → Indonesia Document Legalisation Corridor 2026 (Hague Apostille Since June 2022)",
  "category": "Legalization",
  "tags": [
   "indonesia",
   "apostille",
   "kitas",
   "imta",
   "disdukcapil"
  ],
  "readMinutes": 8,
  "excerpt": "Indonesia is a Hague Apostille member since 4 June 2022 and Thailand acceded on 30 June 2026 (in force for Thailand 28 February 2027) — Thai documents use MFA Apostille directly without KBRI Bangkok legalisation.",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "philippines-document-legalization-corridor-en-2026",
  "title": "Thailand → Philippines Document Legalisation Corridor 2026 (Hague Apostille Since May 2019)",
  "category": "Legalization",
  "tags": [
   "philippines",
   "apostille",
   "acr-icard",
   "aep",
   "ched",
   "psa"
  ],
  "readMinutes": 8,
  "excerpt": "Philippines has been a Hague Apostille member since 14 May 2019 and Thailand acceded on 30 June 2026 (in force for Thailand 28 February 2027) — Thai documents use Apostille directly for BI, DOLE, PSA, CHED, PRC.",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "malaysia-document-legalization-corridor-en-2026",
  "title": "Thailand → Malaysia Document Legalisation Corridor 2026 (Non-Hague + High Commission Bangkok)",
  "category": "Legalization",
  "tags": [
   "malaysia",
   "embassy",
   "ep-pass",
   "mm2h",
   "jpn",
   "wisma-putra"
  ],
  "readMinutes": 9,
  "excerpt": "Malaysia is not a Hague Apostille party — Thai documents still require the full chain: MFA + High Commission of Malaysia Bangkok + Wisma Putra Putrajaya for EP, DP, MM2H, and JPN filings.",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "sri-lanka-document-legalization-corridor-en-2026",
  "title": "Thai → Sri Lanka 2026: Apostille Now Accepted After 5 Jan 2025",
  "category": "Legalization",
  "tags": [
   "sri-lanka",
   "apostille",
   "ugc",
   "registrar-general",
   "immigration-lk"
  ],
  "readMinutes": 9,
  "excerpt": "Sri Lanka acceded to the Hague Apostille Convention with effect from 5 January 2025 and Thailand on 28 February 2027 — Thai documents now require only an MFA Apostille for the Department of Immigration & Emigration, Registrar General Department, and University Grants Commission.",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "bangladesh-document-legalization-corridor-en-2026",
  "title": "Thai → Bangladesh 2026: BIDA, Bangladesh Bank, Registrar Office",
  "category": "Legalization",
  "tags": [
   "bangladesh",
   "embassy",
   "bida",
   "work-permit-bd",
   "mofa-dhaka"
  ],
  "readMinutes": 9,
  "excerpt": "Bangladesh has not joined the Hague Apostille Convention — Thai documents still require the full chain: MFA + Embassy of Bangladesh Bangkok (Thonglor) + MOFA Dhaka before BIDA, Bangladesh Bank, or the Registrar Office accept them.",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "pakistan-document-legalization-corridor-en-2026",
  "title": "Thai → Pakistan 2026: NADRA, FIA, MOFA Islamabad",
  "category": "Legalization",
  "tags": [
   "pakistan",
   "embassy",
   "nadra",
   "fia",
   "mofa-islamabad",
   "muslim-family-laws"
  ],
  "readMinutes": 9,
  "excerpt": "Pakistan has not acceded to the Hague Apostille Convention — Thai documents still require the full chain: MFA + Embassy of Pakistan Bangkok (Sukhumvit 31) + MOFA Islamabad before NADRA, FIA, BISP, or the Board of Revenue accept them.",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "nepal-document-legalization-corridor-en-2026",
  "title": "Thai → Nepal 2026: DAO Marriage, CRO Company, Immigration",
  "category": "Legalization",
  "tags": [
   "nepal",
   "embassy",
   "cro-nepal",
   "dao",
   "mofa-kathmandu",
   "singha-durbar"
  ],
  "readMinutes": 9,
  "excerpt": "Nepal has not acceded to the Hague Apostille Convention — Thai documents require the full chain: MFA + Embassy of Nepal Bangkok + MOFA Kathmandu (Singha Durbar) before the Department of Immigration, the Company Registrar Office (CRO), or the District Administration Office (DAO) for marriage accept them.",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-28",
  "updatedAt": "2026-06-28"
 },
 {
  "slug": "brazil-document-legalization-corridor-en-2026",
  "title": "Thailand → Brazil 2026: Apostille, Cartório, Receita Federal, INM",
  "category": "Legalization",
  "tags": [
   "brazil",
   "apostille",
   "cartorio",
   "receita-federal",
   "tradutor-juramentado"
  ],
  "readMinutes": 9,
  "excerpt": "Brazil acceded to the Hague Apostille Convention with effect from 14 August 2016. Thai MFA Apostille is accepted directly by Receita Federal, Cartório, Polícia Federal and Junta Comercial. The Brazilian Embassy in Bangkok ceased Thai-document legalisation in 2016.",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-29",
  "updatedAt": "2026-06-29"
 },
 {
  "slug": "mexico-document-legalization-corridor-en-2026",
  "title": "Thailand → Mexico 2026: Apostille, INM, Registro Civil, SAT",
  "category": "Legalization",
  "tags": [
   "mexico",
   "apostille",
   "inm",
   "registro-civil",
   "perito-traductor"
  ],
  "readMinutes": 9,
  "excerpt": "Mexico acceded to the Hague Apostille Convention with effect from 14 August 1995. Thai MFA Apostille is accepted directly by INM (immigration), Registro Civil, SAT (tax) and Notario Público across all 32 states.",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-29",
  "updatedAt": "2026-06-29"
 },
 {
  "slug": "south-africa-document-legalization-corridor-en-2026",
  "title": "Thailand → South Africa 2026: Apostille, DHA, CIPC, SAQA",
  "category": "Legalization",
  "tags": [
   "south-africa",
   "apostille",
   "home-affairs",
   "cipc",
   "saqa"
  ],
  "readMinutes": 8,
  "excerpt": "South Africa acceded to the Hague Apostille Convention with effect from 30 April 1995 under the Hague Convention Act 8 of 1996. Thai MFA Apostille is accepted directly by DHA (visa), CIPC (company), DIRCO and SARS.",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-29",
  "updatedAt": "2026-06-29"
 },
 {
  "slug": "egypt-document-legalization-corridor-en-2026",
  "title": "Thailand → Egypt 2026: MFA + Embassy + MOFA Cairo, GAFI, Maazoun",
  "category": "Legalization",
  "tags": [
   "egypt",
   "embassy",
   "gafi",
   "mofa-cairo",
   "maazoun"
  ],
  "readMinutes": 9,
  "excerpt": "Egypt has not joined the Hague Apostille Convention. Thai documents require the full chain: MFA + Embassy of Egypt in Bangkok (Thonglor Soi 10) + MOFA Cairo (Tahrir) before GAFI, Notary Public Egypt, Personal Status Court or the Ministry of Manpower.",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-29",
  "updatedAt": "2026-06-29"
 },
 {
  "slug": "nigeria-document-legalization-corridor-en-2026",
  "title": "Thai → Nigeria Document Corridor 2026: MFA + Embassy + MOFA Abuja",
  "category": "Legalization",
  "tags": [
   "nigeria",
   "embassy",
   "cac",
   "mofa-abuja",
   "nis"
  ],
  "readMinutes": 8,
  "excerpt": "Nigeria has not joined the Hague Apostille Convention. Thai documents must complete the full chain: MFA Thailand + Embassy of Nigeria Bangkok (Sathorn) + MOFA Abuja before use at CAC, NIS, Federal High Court or Marriage Registry.",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-29",
  "updatedAt": "2026-06-29"
 },
 {
  "slug": "kenya-document-legalization-corridor-en-2026",
  "title": "Thai → Kenya Document Corridor 2026: Apostille Hague Direct",
  "category": "Legalization",
  "tags": [
   "kenya",
   "apostille",
   "ecitizen",
   "kra",
   "hague-2025"
  ],
  "readMinutes": 8,
  "excerpt": "Kenya acceded to the Hague Apostille Convention on 14 January 2025. Thai documents bearing an MFA Apostille are accepted directly at eCitizen, KRA, Registrar of Companies — no Embassy of Kenya Bangkok step required.",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-29",
  "updatedAt": "2026-06-29"
 },
 {
  "slug": "argentina-document-legalization-corridor-en-2026",
  "title": "Thai → Argentina Corridor 2026: Apostille + Traductor Público",
  "category": "Legalization",
  "tags": [
   "argentina",
   "apostille",
   "registro-civil",
   "afip",
   "igj"
  ],
  "readMinutes": 8,
  "excerpt": "Argentina has been a Hague Apostille member since 18 February 1988. Thai MFA Apostille is accepted directly at Registro Civil, AFIP, IGJ — but Spanish translation must be done in Argentina by a Traductor Público Juramentado registered with CTPCBA.",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-29",
  "updatedAt": "2026-06-29"
 },
 {
  "slug": "chile-document-legalization-corridor-en-2026",
  "title": "Thai → Chile Corridor 2026: Apostille + Traductor Oficial",
  "category": "Legalization",
  "tags": [
   "chile",
   "apostille",
   "registro-civil",
   "sii",
   "cbr"
  ],
  "readMinutes": 8,
  "excerpt": "Chile acceded to the Hague Apostille Convention on 30 August 2016. Thai MFA Apostille is accepted directly at Registro Civil, SII, CBR — but Spanish translation must be done in Chile by a Traductor Oficial registered with the Ministerio de Relaciones Exteriores.",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-29",
  "updatedAt": "2026-06-29"
 },
 {
  "slug": "russia-document-legalization-corridor-en-2026",
  "title": "Thailand → Russia Legalisation 2026: Apostille + Notariat",
  "category": "Legalization",
  "tags": [
   "russia",
   "apostille",
   "zags",
   "rosreestr",
   "notariat"
  ],
  "readMinutes": 9,
  "excerpt": "The Russian Federation succeeded the USSR's Hague Apostille membership on 31 May 1992. Thai MFA Apostille is accepted directly by ZAGS, Rosreestr, FNS, Notariat — but Russian Sworn Translation + Notarius certification is mandatory under Fundamental Notarial Law 4462-1/1993.",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-30",
  "updatedAt": "2026-06-30"
 },
 {
  "slug": "turkey-document-legalization-corridor-en-2026",
  "title": "Thailand → Türkiye Legalisation 2026: Apostille + Noter",
  "category": "Legalization",
  "tags": [
   "turkey",
   "apostille",
   "nufus",
   "tapu",
   "yeminli-tercuman"
  ],
  "readMinutes": 9,
  "excerpt": "Türkiye Cumhuriyeti joined Hague Apostille on 29 September 1985. Thai MFA Apostille is accepted directly by Nüfus (civil registry), Tapu Sicil (land registry), MERSİS (company registry), and Noter nationwide. Türkçe translation by Yeminli Tercüman + Noter Tasdiki is mandatory under Notarial Law 1512/1972.",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-30",
  "updatedAt": "2026-06-30"
 },
 {
  "slug": "israel-document-legalization-corridor-en-2026",
  "title": "Thailand → Israel Legalisation 2026: Apostille + Notary",
  "category": "Legalization",
  "tags": [
   "israel",
   "apostille",
   "misrad-hapnim",
   "rabbinical-court",
   "tabu"
  ],
  "readMinutes": 9,
  "excerpt": "The State of Israel joined Hague Apostille on 14 August 1978. Thai MFA Apostille is accepted directly by Misrad Hapnim (Interior Ministry), Tabu (Land Registry), PIBA (Population & Immigration), Rabbinical Court — but Hebrew translation + Notary Israel per Notaries Law 5736-1976 is mandatory.",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-30",
  "updatedAt": "2026-06-30"
 },
 {
  "slug": "saudi-arabia-document-legalization-corridor-en-2026",
  "title": "Thailand → Saudi Arabia Legalisation 2026: MOFA + Tasdeeq",
  "category": "Legalization",
  "tags": [
   "saudi-arabia",
   "embassy",
   "tasdeeq",
   "qiwa",
   "vision-2030"
  ],
  "readMinutes": 9,
  "excerpt": "The Kingdom of Saudi Arabia is not a Hague Apostille member. Thai documents must complete the full chain: MFA + Embassy of Saudi Arabia Bangkok (Sathorn 12) + Tasdeeq MOFA Riyadh before being accepted by MOL Qiwa, MOJ Najiz, Absher, MOH (Iqama, Family Visit, Work Permit) under Vision 2030 digital reforms.",
  "author": "NYC Document Team",
  "publishedAt": "2026-06-30",
  "updatedAt": "2026-06-30"
 },
 {
  "slug": "iran-document-legalization-corridor-en-2026",
  "title": "Thai Documents → Iran 2026: MFA + Embassy + MOFA Tehran Tasdiq",
  "category": "Legalization",
  "tags": [
   "iran",
   "embassy",
   "tasdiq",
   "mahzar",
   "non-hague"
  ],
  "readMinutes": 8,
  "excerpt": "The Islamic Republic of Iran has not joined the Hague Apostille Convention. Thai documents must complete the three-stage Tasdiq chain (MFA Thailand + Embassy of Iran Bangkok + MOFA Tehran) before use with Sazman-e Sabt-e Ahval (Civil Registry), Mahzar (Notary Public), NAJA, Sazman-e Sabt-e Asnad va Amlak under Civil Code 1928 and Notaries Law 1316/1937. Sanctions screening (OFAC SDN, EU CFSP, UK OFSI) is mandatory.",
  "author": "NYC Document Team",
  "publishedAt": "2026-07-01",
  "updatedAt": "2026-07-01"
 },
 {
  "slug": "iraq-document-legalization-corridor-en-2026",
  "title": "Thai Documents → Iraq 2026: MFA + Embassy + MOFA Baghdad",
  "category": "Legalization",
  "tags": [
   "iraq",
   "embassy",
   "tasdiq",
   "baghdad",
   "non-hague"
  ],
  "readMinutes": 8,
  "excerpt": "The Republic of Iraq has not joined the Hague Apostille Convention. Thai documents must complete the chain MFA + Embassy of Iraq Bangkok + Tasdiq MOFA Baghdad (Green Zone Authentication Department) before use with Da'irat Al-Ahwal Al-Madaniya (Civil Status), Catasta (Land Registry), MOLSA, Kimadia (MOH), MOHESR under Civil Code 40/1951 + Personal Status Law 188/1959. KRG (Erbil) follows a separate procedure.",
  "author": "NYC Document Team",
  "publishedAt": "2026-07-01",
  "updatedAt": "2026-07-01"
 },
 {
  "slug": "jordan-document-legalization-corridor-en-2026",
  "title": "Thai Documents → Jordan 2026: MFA + Embassy + MOFA Amman",
  "category": "Legalization",
  "tags": [
   "jordan",
   "embassy",
   "tasdiq",
   "amman",
   "non-hague"
  ],
  "readMinutes": 8,
  "excerpt": "The Hashemite Kingdom of Jordan has not joined the Hague Apostille Convention. Thai documents must complete the chain MFA + Embassy of Jordan Bangkok + Tasdiq MOFA Amman (4th Circle, Department of Authentication) before use with Da'irat Al-Ahwal Al-Madaniya wa Al-Jawazat, MOL (Tasreeh Amal), Sharia Court, Department of Lands and Survey under Civil Code 43/1976 + Personal Status Law 36/2010. ASEZA (Aqaba) operates a special-zone fast track.",
  "author": "NYC Document Team",
  "publishedAt": "2026-07-01",
  "updatedAt": "2026-07-01"
 },
 {
  "slug": "lebanon-document-legalization-corridor-en-2026",
  "title": "Thai Documents → Lebanon 2026: MFA + Embassy + MOFA Beirut",
  "category": "Legalization",
  "tags": [
   "lebanon",
   "embassy",
   "tasdiq",
   "beirut",
   "non-hague"
  ],
  "readMinutes": 8,
  "excerpt": "The Lebanese Republic has not joined the Hague Apostille Convention. Thai documents must complete the chain MFA + Embassy of Lebanon Bangkok + Tasdiq MOFA Beirut (Achrafieh) + the relevant confessional court among 18 sects (Maronite, Sunni, Shia, Druze, etc.) under Decree 60/L.R. 1936. Bangkok only hosts an Honorary Consulate; certified legalisation routes via Kuala Lumpur or Riyadh.",
  "author": "NYC Document Team",
  "publishedAt": "2026-07-01",
  "updatedAt": "2026-07-01"
 },
 {
  "slug": "qatar-document-legalization-corridor-en-2026",
  "title": "Thailand → Qatar Document Legalisation 2026: MFA + Embassy + MOFA Doha",
  "category": "Legalization",
  "tags": [
   "qatar",
   "embassy",
   "tasdiq",
   "doha",
   "non-hague",
   "gcc"
  ],
  "readMinutes": 8,
  "excerpt": "The State of Qatar has not signed the Hague Apostille Convention 1961. Thai documents require the three-stage Tasdiq chain: source-country MFA + Embassy of Qatar + MOFA Doha Authentication Department before acceptance by MOI (Metrash2/Hukoomi), MADLSA, MOPH (DHP), Sharia Court, and QFC under Civil Code 22/2004 and Family Law 22/2006.",
  "author": "NYC Document Team",
  "publishedAt": "2026-07-15",
  "updatedAt": "2026-07-15"
 },
 {
  "slug": "kuwait-document-legalization-corridor-en-2026",
  "title": "Thailand → Kuwait Document Legalisation 2026: MFA + Embassy + MOFA Kuwait City",
  "category": "Legalization",
  "tags": [
   "kuwait",
   "embassy",
   "tasdiq",
   "non-hague",
   "gcc"
  ],
  "readMinutes": 8,
  "excerpt": "The State of Kuwait has not signed the Hague Apostille Convention 1961. Thai documents require the three-stage Tasdiq chain before acceptance by Public Authority of Manpower (PAM), MOI, MOH, and the Family Court (Mahkamat Al-Usra) under Civil Code 67/1980 and Personal Status Law 51/1984.",
  "author": "NYC Document Team",
  "publishedAt": "2026-07-15",
  "updatedAt": "2026-07-15"
 },
 {
  "slug": "oman-document-legalization-corridor-en-2026",
  "title": "Thailand → Oman Document Legalisation 2026: MFA + Embassy + MOFA Muscat",
  "category": "Legalization",
  "tags": [
   "oman",
   "embassy",
   "tasdiq",
   "muscat",
   "non-hague",
   "gcc"
  ],
  "readMinutes": 8,
  "excerpt": "The Sultanate of Oman has not signed the Hague Apostille Convention 1961. Thai documents require MFA + Embassy of Oman Bangkok + MOFA Muscat Tasdiq (Al Khuwair) before MoL (Invest Easy), Royal Oman Police (ROP), MOH (Sahaty), Sharia Court, and MOHERI under Basic Law 101/1996 and Personal Status Law 32/1997.",
  "author": "NYC Document Team",
  "publishedAt": "2026-07-15",
  "updatedAt": "2026-07-15"
 },
 {
  "slug": "bahrain-document-legalization-corridor-en-2026",
  "title": "Thailand → Bahrain Document Legalisation 2026: Apostille + Arabic Translation Manama",
  "category": "Legalization",
  "tags": [
   "bahrain",
   "apostille",
   "hague",
   "manama",
   "gcc"
  ],
  "readMinutes": 8,
  "excerpt": "The Kingdom of Bahrain joined the Hague Apostille Convention 1961 effective 31 Dec 2013 — the only GCC member. Thai documents bearing an MFA Apostille are accepted directly by LMRA, MOI eKey, NHRA, Sharia Court, SLRB, MOE Equivalency, EDB, and CBB, with no Embassy of Bahrain step required — 60% faster and 50% cheaper than Saudi/UAE/Qatar/Kuwait/Oman.",
  "author": "NYC Document Team",
  "publishedAt": "2026-07-15",
  "updatedAt": "2026-07-15"
 },
 {
  "slug": "syria-document-legalization-corridor-en-2026",
  "title": "Syria Document Legalisation Corridor 2026 — Chain, Sanctions, and War-Zone Risk",
  "category": "Legalization",
  "tags": [
   "syria",
   "tasdiq",
   "sanctions",
   "ofac",
   "embassy-legalization"
  ],
  "readMinutes": 16,
  "excerpt": "Syria is FCDO Red + OFAC CAESAR sanctioned, but ordinary Personal Status documents can still be legalised via Beirut or Amman if sanctions screening clears.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-29",
  "updatedAt": "2026-06-29"
 },
 {
  "slug": "yemen-document-legalization-corridor-en-2026",
  "title": "Yemen Document Legalisation Corridor 2026 — ROYG Aden vs Houthi Sana'a",
  "category": "Legalization",
  "tags": [
   "yemen",
   "tasdiq",
   "sanctions",
   "houthi",
   "embassy-legalization"
  ],
  "readMinutes": 14,
  "excerpt": "Yemen has two governments — ROYG (Aden, UN-recognised) and Houthi (Sana'a, not recognised). The chain depends on which government issued the document.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-29",
  "updatedAt": "2026-06-29"
 },
 {
  "slug": "libya-document-legalization-corridor-en-2026",
  "title": "Libya Document Legalisation Corridor 2026 — GNU Tripoli vs HoR Tobruk",
  "category": "Legalization",
  "tags": [
   "libya",
   "tasdiq",
   "sanctions",
   "embassy-legalization"
  ],
  "readMinutes": 14,
  "excerpt": "Libya has two governments — GNU Tripoli (UN-recognised) and HoR Tobruk + LNA Haftar. The chain depends on the document's destination.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-29",
  "updatedAt": "2026-06-29"
 },
 {
  "slug": "palestine-document-legalization-corridor-en-2026",
  "title": "Palestine Document Legalisation Corridor 2026 — PA Ramallah vs Hamas Gaza",
  "category": "Legalization",
  "tags": [
   "palestine",
   "tasdiq",
   "embassy-legalization",
   "west-bank",
   "gaza"
  ],
  "readMinutes": 14,
  "excerpt": "Palestine splits into two areas — PA West Bank (Ramallah-based) and Gaza (Hamas-controlled since 2007). The chain depends on destination + Israel COGAT coordination.",
  "author": "NYC Legal Team",
  "publishedAt": "2026-06-29",
  "updatedAt": "2026-06-29"
 }
] as BlogCardMeta[];
